// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root, .light, .light-theme {
  --blue-1: #fbfdff;
  --blue-2: #f4faff;
  --blue-3: #e6f4fe;
  --blue-4: #d5efff;
  --blue-5: #c2e5ff;
  --blue-6: #acd8fc;
  --blue-7: #8ec8f6;
  --blue-8: #5eb1ef;
  --blue-9: #0090ff;
  --blue-10: #0588f0;
  --blue-11: #0d74ce;
  --blue-12: #113264;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, .light, .light-theme {
      --blue-1: color(display-p3 0.986 0.992 0.999);
      --blue-2: color(display-p3 0.96 0.979 0.998);
      --blue-3: color(display-p3 0.912 0.956 0.991);
      --blue-4: color(display-p3 0.853 0.932 1);
      --blue-5: color(display-p3 0.788 0.894 0.998);
      --blue-6: color(display-p3 0.709 0.843 0.976);
      --blue-7: color(display-p3 0.606 0.777 0.947);
      --blue-8: color(display-p3 0.451 0.688 0.917);
      --blue-9: color(display-p3 0.247 0.556 0.969);
      --blue-10: color(display-p3 0.234 0.523 0.912);
      --blue-11: color(display-p3 0.15 0.44 0.84);
      --blue-12: color(display-p3 0.102 0.193 0.379);
    }
  }
}

.dark, .dark-theme {
  --blue-1: #0d1520;
  --blue-2: #111927;
  --blue-3: #0d2847;
  --blue-4: #003362;
  --blue-5: #004074;
  --blue-6: #104d87;
  --blue-7: #205d9e;
  --blue-8: #2870bd;
  --blue-9: #0090ff;
  --blue-10: #3b9eff;
  --blue-11: #70b8ff;
  --blue-12: #c2e6ff;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    .dark, .dark-theme {
      --blue-1: color(display-p3 0.057 0.081 0.122);
      --blue-2: color(display-p3 0.072 0.098 0.147);
      --blue-3: color(display-p3 0.078 0.154 0.27);
      --blue-4: color(display-p3 0.033 0.197 0.37);
      --blue-5: color(display-p3 0.08 0.245 0.441);
      --blue-6: color(display-p3 0.14 0.298 0.511);
      --blue-7: color(display-p3 0.195 0.361 0.6);
      --blue-8: color(display-p3 0.239 0.434 0.72);
      --blue-9: color(display-p3 0.247 0.556 0.969);
      --blue-10: color(display-p3 0.344 0.612 0.973);
      --blue-11: color(display-p3 0.49 0.72 1);
      --blue-12: color(display-p3 0.788 0.898 0.99);
    }
  }
}

:root, .light, .light-theme {
  --slate-1: #fcfcfd;
  --slate-2: #f9f9fb;
  --slate-3: #f0f0f3;
  --slate-4: #e8e8ec;
  --slate-5: #e0e1e6;
  --slate-6: #d9d9e0;
  --slate-7: #cdced6;
  --slate-8: #b9bbc6;
  --slate-9: #8b8d98;
  --slate-10: #80838d;
  --slate-11: #60646c;
  --slate-12: #1c2024;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, .light, .light-theme {
      --slate-1: color(display-p3 0.988 0.988 0.992);
      --slate-2: color(display-p3 0.976 0.976 0.984);
      --slate-3: color(display-p3 0.94 0.941 0.953);
      --slate-4: color(display-p3 0.908 0.909 0.925);
      --slate-5: color(display-p3 0.88 0.881 0.901);
      --slate-6: color(display-p3 0.85 0.852 0.876);
      --slate-7: color(display-p3 0.805 0.808 0.838);
      --slate-8: color(display-p3 0.727 0.733 0.773);
      --slate-9: color(display-p3 0.547 0.553 0.592);
      --slate-10: color(display-p3 0.503 0.512 0.549);
      --slate-11: color(display-p3 0.379 0.392 0.421);
      --slate-12: color(display-p3 0.113 0.125 0.14);
    }
  }
}

.dark, .dark-theme {
  --slate-1: #111113;
  --slate-2: #18191b;
  --slate-3: #212225;
  --slate-4: #272a2d;
  --slate-5: #2e3135;
  --slate-6: #363a3f;
  --slate-7: #43484e;
  --slate-8: #5a6169;
  --slate-9: #696e77;
  --slate-10: #777b84;
  --slate-11: #b0b4ba;
  --slate-12: #edeef0;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    .dark, .dark-theme {
      --slate-1: color(display-p3 0.067 0.067 0.074);
      --slate-2: color(display-p3 0.095 0.098 0.105);
      --slate-3: color(display-p3 0.13 0.135 0.145);
      --slate-4: color(display-p3 0.156 0.163 0.176);
      --slate-5: color(display-p3 0.183 0.191 0.206);
      --slate-6: color(display-p3 0.215 0.226 0.244);
      --slate-7: color(display-p3 0.265 0.28 0.302);
      --slate-8: color(display-p3 0.357 0.381 0.409);
      --slate-9: color(display-p3 0.415 0.431 0.463);
      --slate-10: color(display-p3 0.469 0.483 0.514);
      --slate-11: color(display-p3 0.692 0.704 0.728);
      --slate-12: color(display-p3 0.93 0.933 0.94);
    }
  }
}

:root, .light, .light-theme {
  --grass-1: #fbfefb;
  --grass-2: #f5fbf5;
  --grass-3: #e9f6e9;
  --grass-4: #daf1db;
  --grass-5: #c9e8ca;
  --grass-6: #b2ddb5;
  --grass-7: #94ce9a;
  --grass-8: #65ba74;
  --grass-9: #46a758;
  --grass-10: #3e9b4f;
  --grass-11: #2a7e3b;
  --grass-12: #203c25;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, .light, .light-theme {
      --grass-1: color(display-p3 0.986 0.996 0.985);
      --grass-2: color(display-p3 0.966 0.983 0.964);
      --grass-3: color(display-p3 0.923 0.965 0.917);
      --grass-4: color(display-p3 0.872 0.94 0.865);
      --grass-5: color(display-p3 0.811 0.908 0.802);
      --grass-6: color(display-p3 0.733 0.864 0.724);
      --grass-7: color(display-p3 0.628 0.803 0.622);
      --grass-8: color(display-p3 0.477 0.72 0.482);
      --grass-9: color(display-p3 0.38 0.647 0.378);
      --grass-10: color(display-p3 0.344 0.598 0.342);
      --grass-11: color(display-p3 0.263 0.488 0.261);
      --grass-12: color(display-p3 0.151 0.233 0.153);
    }
  }
}

:root, .light, .light-theme {
  --cyan-1: #fafdfe;
  --cyan-2: #f2fafb;
  --cyan-3: #def7f9;
  --cyan-4: #caf1f6;
  --cyan-5: #b5e9f0;
  --cyan-6: #9ddde7;
  --cyan-7: #7dcedc;
  --cyan-8: #3db9cf;
  --cyan-9: #00a2c7;
  --cyan-10: #0797b9;
  --cyan-11: #107d98;
  --cyan-12: #0d3c48;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, .light, .light-theme {
      --cyan-1: color(display-p3 0.982 0.992 0.996);
      --cyan-2: color(display-p3 0.955 0.981 0.984);
      --cyan-3: color(display-p3 0.888 0.965 0.975);
      --cyan-4: color(display-p3 0.821 0.941 0.959);
      --cyan-5: color(display-p3 0.751 0.907 0.935);
      --cyan-6: color(display-p3 0.671 0.862 0.9);
      --cyan-7: color(display-p3 0.564 0.8 0.854);
      --cyan-8: color(display-p3 0.388 0.715 0.798);
      --cyan-9: color(display-p3 0.282 0.627 0.765);
      --cyan-10: color(display-p3 0.264 0.583 0.71);
      --cyan-11: color(display-p3 0.08 0.48 0.63);
      --cyan-12: color(display-p3 0.108 0.232 0.277);
    }
  }
}

:root, .light, .light-theme {
  --amber-1: #fefdfb;
  --amber-2: #fefbe9;
  --amber-3: #fff7c2;
  --amber-4: #ffee9c;
  --amber-5: #fbe577;
  --amber-6: #f3d673;
  --amber-7: #e9c162;
  --amber-8: #e2a336;
  --amber-9: #ffc53d;
  --amber-10: #ffba18;
  --amber-11: #ab6400;
  --amber-12: #4f3422;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, .light, .light-theme {
      --amber-1: color(display-p3 0.995 0.992 0.985);
      --amber-2: color(display-p3 0.994 0.986 0.921);
      --amber-3: color(display-p3 0.994 0.969 0.782);
      --amber-4: color(display-p3 0.989 0.937 0.65);
      --amber-5: color(display-p3 0.97 0.902 0.527);
      --amber-6: color(display-p3 0.936 0.844 0.506);
      --amber-7: color(display-p3 0.89 0.762 0.443);
      --amber-8: color(display-p3 0.85 0.65 0.3);
      --amber-9: color(display-p3 1 0.77 0.26);
      --amber-10: color(display-p3 0.959 0.741 0.274);
      --amber-11: color(display-p3 0.64 0.4 0);
      --amber-12: color(display-p3 0.294 0.208 0.145);
    }
  }
}

:root, .light, .light-theme {
  --red-1: #fffcfc;
  --red-2: #fff7f7;
  --red-3: #feebec;
  --red-4: #ffdbdc;
  --red-5: #ffcdce;
  --red-6: #fdbdbe;
  --red-7: #f4a9aa;
  --red-8: #eb8e90;
  --red-9: #e5484d;
  --red-10: #dc3e42;
  --red-11: #ce2c31;
  --red-12: #641723;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, .light, .light-theme {
      --red-1: color(display-p3 0.998 0.989 0.988);
      --red-2: color(display-p3 0.995 0.971 0.971);
      --red-3: color(display-p3 0.985 0.925 0.925);
      --red-4: color(display-p3 0.999 0.866 0.866);
      --red-5: color(display-p3 0.984 0.812 0.811);
      --red-6: color(display-p3 0.955 0.751 0.749);
      --red-7: color(display-p3 0.915 0.675 0.672);
      --red-8: color(display-p3 0.872 0.575 0.572);
      --red-9: color(display-p3 0.83 0.329 0.324);
      --red-10: color(display-p3 0.798 0.294 0.285);
      --red-11: color(display-p3 0.744 0.234 0.222);
      --red-12: color(display-p3 0.36 0.115 0.143);
    }
  }
}

/** Code mirror */

.mdxeditor .cm-editor {
    --sp-font-mono: var(--font-mono);
    --sp-font-body: var(--font-body);
    padding: var(--sp-space-4) 0;
  }

.mdxeditor .sp-editor .cm-editor {
    padding-bottom: 0;
  }

.mdxeditor .cm-scroller {
    padding: 0 !important;
  }

.mdxeditor .cm-focused {
    outline: none;
  }

.mdxeditor .sp-wrapper {
    overflow: hidden;
  }

.mdxeditor .sp-layout {
    border: none;
  }

.mdxeditor .sp-cm pre {
      white-space: break-spaces;
      word-break: break-word;
      overflow-wrap: anywhere;
      flex-shrink: 1;
    }

/** Diff viewer */

.mdxeditor .cm-mergeView .cm-scroller {
    font-family: var(--font-mono);
    line-height: 1.3rem;
    font-size: var(--text-xs);
  }

/** Diff viewer */

.mdxeditor .cm-sourceView .cm-scroller {
    font-family: var(--font-mono);
    line-height: 1.3rem;
    font-size: var(--text-xs);
  }

.mdxeditor .cm-gutters {
    background: transparent;
    font-size: var(--text-xxs);
  }

.mdxeditor .cm-activeLine {
    background: transparent;
  }

.mdxeditor .cm-tooltip-autocomplete {
    background: var(--baseBgSubtle);
  }

.mdxeditor hr.selected[data-lexical-decorator=true] {
    outline: 2px solid highlight;
  }
._editorRoot_uazmk_53 {
  --accentBase: var(--blue-1);
  --accentBgSubtle: var(--blue-2);
  --accentBg: var(--blue-3);
  --accentBgHover: var(--blue-4);
  --accentBgActive: var(--blue-5);
  --accentLine: var(--blue-6);
  --accentBorder: var(--blue-7);
  --accentBorderHover: var(--blue-8);
  --accentSolid: var(--blue-9);
  --accentSolidHover: var(--blue-10);
  --accentText: var(--blue-11);
  --accentTextContrast: var(--blue-12);

  --basePageBg: white;
  --baseBase: var(--slate-1);
  --baseBgSubtle: var(--slate-2);
  --baseBg: var(--slate-3);
  --baseBgHover: var(--slate-4);
  --baseBgActive: var(--slate-5);
  --baseLine: var(--slate-6);
  --baseBorder: var(--slate-7);
  --baseBorderHover: var(--slate-8);
  --baseSolid: var(--slate-9);
  --baseSolidHover: var(--slate-10);
  --baseText: var(--slate-11);
  --baseTextContrast: var(--slate-12);

  --admonitionTipBg: var(--cyan-4);
  --admonitionTipBorder: var(--cyan-8);

  --admonitionInfoBg: var(--grass-4);
  --admonitionInfoBorder: var(--grass-8);

  --admonitionCautionBg: var(--amber-4);
  --admonitionCautionBorder: var(--amber-8);

  --admonitionDangerBg: var(--red-4);
  --admonitionDangerBorder: var(--red-8);

  --admonitionNoteBg: var(--slate-4);
  --admonitionNoteBorder: var(--slate-8);

  --error-color: var(--red-10);

  --spacing-0: 0px;
  --spacing-px: 1px;
  --spacing-0_5: 0.125rem;
  --spacing-1: 0.25rem;
  --spacing-1_5: 0.375rem;
  --spacing-2: 0.5rem;
  --spacing-2_5: 0.625rem;
  --spacing-3: 0.75rem;
  --spacing-3_5: 0.875rem;
  --spacing-4: 1rem;
  --spacing-5: 1.25rem;
  --spacing-6: 1.5rem;
  --spacing-7: 1.75rem;
  --spacing-8: 2rem;
  --spacing-9: 2.25rem;
  --spacing-10: 2.5rem;
  --spacing-11: 2.75rem;
  --spacing-12: 3rem;
  --spacing-14: 3.5rem;
  --spacing-16: 4rem;
  --spacing-20: 5rem;
  --spacing-24: 6rem;
  --spacing-28: 7rem;
  --spacing-32: 8rem;
  --spacing-36: 9rem;
  --spacing-40: 10rem;
  --spacing-44: 11rem;
  --spacing-48: 12rem;
  --spacing-52: 13rem;
  --spacing-56: 14rem;
  --spacing-60: 15rem;
  --spacing-64: 16rem;
  --spacing-72: 18rem;
  --spacing-80: 20rem;
  --spacing-96: 24rem;

  --radius-none: 0px;
  --radius-small: var(--spacing-0_5);
  --radius-base: var(--spacing-1);
  --radius-medium: var(--spacing-1_5);
  --radius-large: var(--spacing-2);
  --radius-extra-large: var(--spacing-3);
  --radius-full: 9999px;

  --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --font-body: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  --text-base: 1rem;
  --text-sm: 0.875rem;
  --text-xs: 0.75rem;
  --text-xxs: 0.6rem;

  font-family: var(--font-body);
  color: var(--baseText);
}

._editorWrapper_uazmk_154 {}

._nestedListItem_uazmk_156 {
  list-style: none;
}

._toolbarRoot_uazmk_160 {
  z-index: 2;
  display: flex;
  flex-direction: row;
  gap: var(--spacing-1);
  border-radius: var(--radius-medium);
  padding: var(--spacing-1_5);
  align-items: center;
  overflow-x: auto;
  position: sticky;
  top: 0;
  background-color: var(--baseBg);
  width: inherit;
}

._toolbarRoot_uazmk_160 div[role=separator] {
    margin: var(--spacing-2) var(--spacing-1);
    border-left: 1px solid var(--baseBorder);
    border-right: 1px solid var(--baseBase);
    height: var(--spacing-4);
  }

._toolbarRoot_uazmk_160 svg {
    color: var(--baseTextContrast);
    display: block;
  }

._readOnlyToolbarRoot_uazmk_187 {
  pointer-events: none;
  background: var(--baseBase);
}

._readOnlyToolbarRoot_uazmk_187>div {
    opacity: 0.5;
  }

._toolbarModeSwitch_uazmk_196 {
  opacity: 1 !important;
  margin-left: auto;
  align-self: stretch;
  align-items: stretch;
  display: flex;
  border: 1px solid var(--baseBg);
  border-radius: var(--radius-medium);
  font-size: var(--text-xs);
}

._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206 {
    padding-inline-end: var(--spacing-4);
    padding-inline-start: var(--spacing-4);
  }

._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206:active,
    ._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206[data-state=on] {
      background-color: var(--baseBorder);
    }

._toolbarGroupOfGroups_uazmk_217 {
  display: flex;
  margin: 0 var(--spacing-1);
}

._toolbarToggleSingleGroup_uazmk_222:first-of-type ._toolbarToggleItem_uazmk_206:only-child,
._toolbarToggleSingleGroup_uazmk_222:only-child ._toolbarToggleItem_uazmk_206:first-child,
._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206:first-child {
  border-top-left-radius: var(--radius-base);
  border-bottom-left-radius: var(--radius-base);
}

._toolbarToggleSingleGroup_uazmk_222:last-of-type ._toolbarToggleItem_uazmk_206:only-child,
._toolbarToggleSingleGroup_uazmk_222:only-child ._toolbarToggleItem_uazmk_206:last-child,
._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206:last-child {
  border-top-right-radius: var(--radius-base);
  border-bottom-right-radius: var(--radius-base);
}

._toolbarToggleItem_uazmk_206,
._toolbarButton_uazmk_237 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  padding: var(--spacing-0_5);
}

@media (hover: hover) {
    ._toolbarToggleItem_uazmk_206:hover, ._toolbarButton_uazmk_237:hover {
      background-color: var(--baseBgActive);
    }
  }

._toolbarToggleItem_uazmk_206:active svg, ._toolbarButton_uazmk_237:active svg {
    transform: translate(1px, 1px);
  }

._toolbarToggleItem_uazmk_206[data-state=on],
  ._toolbarButton_uazmk_237[data-state=on],
  ._toolbarToggleItem_uazmk_206:active,
  ._toolbarButton_uazmk_237:active {
    color: var(--baseTextContrast);
    background-color: var(--baseBgActive);
  }

._toolbarToggleItem_uazmk_206[data-disabled], ._toolbarButton_uazmk_237[data-disabled] {
    pointer-events: none;
  }

._toolbarToggleItem_uazmk_206[data-disabled] svg, ._toolbarButton_uazmk_237[data-disabled] svg {
      color: var(--baseBorderHover);
    }

._toolbarButton_uazmk_237 {
  border-radius: var(--radius-base);
}

._toolbarButton_uazmk_237 + ._toolbarButton_uazmk_237 {
  margin-left: var(--spacing-1);
}

._activeToolbarButton_uazmk_274 {
  color: var(--accentText);
}

._toolbarToggleSingleGroup_uazmk_222 {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

._toolbarNodeKindSelectContainer_uazmk_284,
._toolbarButtonDropdownContainer_uazmk_285,
._toolbarCodeBlockLanguageSelectContent_uazmk_286,
._selectContainer_uazmk_287 {
  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));
  z-index: 3;
  width: var(--spacing-36);
  border-bottom-left-radius: var(--radius-base);
  border-bottom-right-radius: var(--radius-base);
  background-color: var(--basePageBg);
  font-size: var(--text-sm);
}

._toolbarButtonDropdownContainer_uazmk_285 {
  border-top-right-radius: var(--radius-base);
}

._toolbarButtonDropdownContainer_uazmk_285 ._selectItem_uazmk_300:first-child {
    border-top-right-radius: var(--radius-base);
  }

._toolbarNodeKindSelectTrigger_uazmk_305,
._toolbarButtonSelectTrigger_uazmk_306,
._selectTrigger_uazmk_307 {
  border: 0;
  background-color: transparent;
  display: flex;
  color: inherit;
  align-items: center;
  width: var(--spacing-36);
  padding: var(--spacing-0_5) var(--spacing-1);
  padding-inline-start: var(--spacing-2);
  border-radius: var(--radius-medium);
  white-space: nowrap;
  flex-wrap: nowrap;
  font-size: var(--text-sm);
  background-color: var(--basePageBg);
  margin: 0 var(--spacing-1);
}

._toolbarNodeKindSelectTrigger_uazmk_305[data-state=open], ._toolbarButtonSelectTrigger_uazmk_306[data-state=open], ._selectTrigger_uazmk_307[data-state=open] {
    filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));
    border-bottom-right-radius: var(--radius-none);
    border-bottom-left-radius: var(--radius-none);
  }

._selectTrigger_uazmk_307[data-placeholder]>span:first-child {
  color: var(--baseBorderHover);
}

/** used in the sandpack */
._toolbarButtonSelectTrigger_uazmk_306 {
  width: auto;
  padding-inline-start: var(--spacing-2);
  padding-inline-end: var(--spacing-1);
  padding-block: var(--spacing-0_5);
}

._toolbarCodeBlockLanguageSelectTrigger_uazmk_342,
._toolbarCodeBlockLanguageSelectContent_uazmk_286 {
  width: var(--spacing-48);
}

._toolbarNodeKindSelectItem_uazmk_347,
._selectItem_uazmk_300 {
  cursor: default;
  display: flex;
  padding: var(--spacing-2);
}

._toolbarNodeKindSelectItem_uazmk_347[data-highlighted], ._selectItem_uazmk_300[data-highlighted] {
    background-color: var(--baseBg);
  }

._toolbarNodeKindSelectItem_uazmk_347[data-state=checked], ._selectItem_uazmk_300[data-state=checked] {
    color: var(--baseTextContrast);
    background-color: var(--baseBg);
  }

._toolbarNodeKindSelectItem_uazmk_347[data-highlighted], ._selectItem_uazmk_300[data-highlighted] {
    outline: none;
  }

._toolbarNodeKindSelectItem_uazmk_347:last-child, ._selectItem_uazmk_300:last-child {
    border-bottom-left-radius: var(--radius-base);
    border-bottom-right-radius: var(--radius-base);
  }

._toolbarNodeKindSelectDropdownArrow_uazmk_372,
._selectDropdownArrow_uazmk_373 {
  margin-left: auto;
  display: flex;
  align-items: center;
}

._contentEditable_uazmk_379 {
  box-sizing: border-box;
  width: 100%;
  color: var(--baseTextContrast);

  padding: var(--spacing-3);
}

._contentEditable_uazmk_379:focus {
    outline: none;
  }

._codeMirrorWrapper_uazmk_391 {
  margin-bottom: var(--spacing-5);
  border: 1px solid var(--baseLine);
  border-radius: var(--radius-medium);
  overflow: hidden;
  padding: 0.8rem;
  position: relative;
}

._sandPackWrapper_uazmk_400 {
  margin-bottom: var(--spacing-5);
  border: 1px solid var(--baseLine);
  border-radius: var(--radius-medium);
  overflow: hidden;
  position: relative;
}

._codeMirrorToolbar_uazmk_408 {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-1);
  z-index: 1;
  background-color: var(--baseBase);
  border-bottom-left-radius: var(--radius-base);
}

._frontmatterWrapper_uazmk_412 {
  border-radius: var(--radius-medium);
  padding: var(--spacing-3);
  background-color: var(--baseBgSubtle);
}

._frontmatterWrapper_uazmk_412[data-expanded=true] {
    margin-bottom: var(--spacing-10);
  }

._frontmatterToggleButton_uazmk_422 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  font-size: var(--text-sm);
}

._propertyPanelTitle_uazmk_430 {
  font-size: var(--text-xs);
  font-weight: 400;
  margin: 0;
  padding-top: var(--spacing-2);
  padding-left: var(--spacing-2);
}

._propertyEditorTable_uazmk_438 {
  table-layout: fixed;
  border-spacing: var(--spacing-2);
}

._propertyEditorTable_uazmk_438 th {
    text-align: left;
    font-size: var(--text-sm);
    padding: var(--spacing-2) var(--spacing-3);
  }

._propertyEditorTable_uazmk_438 col:nth-child(1) {
    width: 30%;
  }

._propertyEditorTable_uazmk_438 col:nth-child(2) {
    width: 70%;
  }

._propertyEditorTable_uazmk_438 td:last-child ._iconButton_uazmk_456 {
    margin-left: var(--spacing-4);
    margin-right: var(--spacing-4);
  }

._propertyEditorTable_uazmk_438 ._readOnlyColumnCell_uazmk_461 {
    padding-left: 0;
  }

._propertyEditorLabelCell_uazmk_466 {
  font-weight: 400;
}

._readOnlyColumnCell_uazmk_461 {
  padding-left: 0;
}

._buttonsFooter_uazmk_474 {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-2);
}

._propertyEditorInput_uazmk_480 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  width: 100%;
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-base);
  border: 1px solid var(--baseBorder);
  background-color: var(--baseBase);
  font-size: var(--text-sm);
}

._iconButton_uazmk_456 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  color: var(--baseText);
}

@media (hover: hover) {
    ._iconButton_uazmk_456:hover {
      color: var(--baseTextContrast);
    }
  }

._iconButton_uazmk_456:disabled,
  ._iconButton_uazmk_456:disabled:hover {
    color: var(--baseLine);
  }

._primaryButton_uazmk_506,
._secondaryButton_uazmk_507 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  padding: var(--spacing-2) var(--spacing-3);
  border: 1px solid var(--accentBorder);
  background-color: var(--accentSolidHover);
  color: var(--baseBase);
  font-size: var(--text-xs);
  border-radius: var(--radius-medium);
}

._primaryButton_uazmk_506:disabled, ._secondaryButton_uazmk_507:disabled {
    background: var(--accentLine);
    border-color: var(--accentBg);
  }

._smallButton_uazmk_522 {
  font-size: var(--text-xs);
  padding: var(--spacing-1) var(--spacing-2);
  border-radius: var(--radius-base);
}

._secondaryButton_uazmk_507 {
  border: 1px solid var(--baseBorder);
  background-color: var(--baseSolidHover);
  color: var(--baseBase);
}

._dialogForm_uazmk_534 {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
}

._linkDialogEditForm_uazmk_540 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-2);
  padding: 0;
}

._linkDialogInputContainer_uazmk_548 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

._linkDialogInputWrapper_uazmk_554 {
  display: flex;
  align-items: center;
  background-color: var(--baseBase);

  border-radius: var(--radius-base);
  border: 1px solid var(--baseBorder);
}

._linkDialogInputWrapper_uazmk_554[data-visible-dropdown=true] {
    border-bottom-left-radius: var(--radius-none);
    border-bottom-right-radius: var(--radius-none);
    border-bottom-width: 0;
  }

._linkDialogInputWrapper_uazmk_554>button {
    border: 0;
    background-color: transparent;
    font-size: inherit;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    all: unset;
    box-sizing: border-box;
    cursor: default;
    padding-right: var(--spacing-2);
  }

._linkDialogInput_uazmk_548,
._dialogInput_uazmk_575 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  width: 20rem;
  padding: var(--spacing-2) var(--spacing-3);
  font-size: var(--text-sm);
}

._linkDialogInput_uazmk_548::-moz-placeholder, ._dialogInput_uazmk_575::-moz-placeholder {
    color: var(--baseBorder);
  }

._linkDialogInput_uazmk_548::placeholder, ._dialogInput_uazmk_575::placeholder {
    color: var(--baseBorder);
  }

._linkDialogAnchor_uazmk_586 {
  position: fixed;
  background-color: highlight;
  z-index: -1;
}

._linkDialogAnchor_uazmk_586[data-visible=true] {
    visibility: visible;
  }

._linkDialogAnchor_uazmk_586[data-visible=false] {
    visibility: hidden;
  }

._linkDialogPopoverContent_uazmk_600,
._tableColumnEditorPopoverContent_uazmk_601,
._dialogContent_uazmk_602 {
  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));
  display: flex;
  align-items: center;
  gap: var(--spacing-0_5);
  border-radius: var(--radius-medium);
  border: 1px solid var(--baseBg);
  background-color: var(--basePageBg);
  padding: var(--spacing-1) var(--spacing-1);
  font-size: var(--text-sm);
}

._largeDialogContent_uazmk_614 {
  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));
  gap: var(--spacing-0_5);
  border-radius: var(--radius-medium);
  border: 1px solid var(--baseBorder);
  background-color: var(--baseBgSubtle);
  padding: var(--spacing-4);
  font-size: var(--text-sm);
}

._dialogTitle_uazmk_624 {
  font-size: var(--text-base);
  font-weight: 600;
  padding-left: var(--spacing-2);
}

._dialogCloseButton_uazmk_630 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  position: absolute;
  top: 10px;
  right: 10px;
}

._popoverContent_uazmk_637 {
  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));
  display: flex;
  align-items: center;
  gap: var(--spacing-0_5);
  border-radius: var(--radius-medium);
  background-color: var(--baseBgSubtle);
  padding: var(--spacing-2) var(--spacing-2);
  font-size: var(--text-sm);
  z-index: 1;
}

._popoverArrow_uazmk_649 {
  fill: var(--basePageBg);
}

._linkDialogPreviewAnchor_uazmk_653 {
  margin-right: var(--spacing-1);
  display: flex;
  align-items: center;
  color: var(--accentText);
  text-decoration: none;

  border: 1px solid transparent;
}

@media (hover: hover) {
    ._linkDialogPreviewAnchor_uazmk_653:hover {
      color: var(--accentSolidHover);
    }
  }

._linkDialogPreviewAnchor_uazmk_653 span {
    max-width: 14rem;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

._tooltipTrigger_uazmk_676 {
  align-self: center;
}

._tooltipContent_uazmk_680 {
  z-index: 2;
  position: relative;
  border-radius: var(--radius-medium);
  padding: var(--spacing-1) var(--spacing-2);
  font-size: var(--text-xs);
  background-color: var(--baseText);
  color: var(--baseBase);
}

._tooltipContent_uazmk_680 svg {
    fill: var(--baseText);
  }

._actionButton_uazmk_694 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  padding: var(--spacing-1);
  color: var(--baseTextContrast);
  padding: var(--spacing-1) var(--spacing-1);
  border-radius: var(--radius-medium);
  color: var(--baseTextContrast);
}

._actionButton_uazmk_694 svg {
    display: block;
  }

@media (hover: hover) {
    ._actionButton_uazmk_694:hover {
      background-color: var(--baseBg);
    }
  }

._actionButton_uazmk_694:active svg {
    transform: translate(1px, 1px);
  }

._actionButton_uazmk_694[data-state=on],
  ._actionButton_uazmk_694:active {
    background-color: var(--baseBg);
    color: var(--baseTextContrast);
  }

._primaryActionButton_uazmk_701 {
  background-color: var(--accentSolid);
  color: var(--baseBase);
}

@media (hover: hover) {
    ._primaryActionButton_uazmk_701:hover {
      background-color: var(--accentSolidHover);
      color: var(--baseBase);
    }
  }

._tableEditor_uazmk_713 {
  table-layout: fixed;
  width: 100%;
  height: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

._tableEditor_uazmk_713 thead>tr>th {
    text-align: right;
  }

._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),
  ._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell="true"]) {
    border: 1px solid var(--baseBgActive);
    padding: var(--spacing-1) var(--spacing-2);
    white-space: normal;
  }

:is(._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell="true"]))>div {
      outline: none;
    }

:is(._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell="true"]))>div>p {
        margin: 0;
      }

[data-active=true]:is(._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell="true"])) {
      outline: solid 1px var(--baseSolid);
    }

._tableEditor_uazmk_713 ._tableColumnEditorTrigger_uazmk_743,
  ._tableEditor_uazmk_713 ._tableRowEditorTrigger_uazmk_744,
  ._tableEditor_uazmk_713 ._addRowButton_uazmk_745,
  ._tableEditor_uazmk_713 ._addColumnButton_uazmk_746,
  ._tableEditor_uazmk_713 ._iconButton_uazmk_456 {
    opacity: .15;
  }

@media (hover: hover) {

      ._tableEditor_uazmk_713:hover ._tableColumnEditorTrigger_uazmk_743,
      ._tableEditor_uazmk_713:hover ._tableRowEditorTrigger_uazmk_744,
      ._tableEditor_uazmk_713:hover ._addRowButton_uazmk_745,
      ._tableEditor_uazmk_713:hover ._addColumnButton_uazmk_746,
      ._tableEditor_uazmk_713:hover ._iconButton_uazmk_456 {
        opacity: 0.3;
      }

        ._tableEditor_uazmk_713:hover ._tableColumnEditorTrigger_uazmk_743:hover, ._tableEditor_uazmk_713:hover ._tableRowEditorTrigger_uazmk_744:hover, ._tableEditor_uazmk_713:hover ._addRowButton_uazmk_745:hover, ._tableEditor_uazmk_713:hover ._addColumnButton_uazmk_746:hover, ._tableEditor_uazmk_713:hover ._iconButton_uazmk_456:hover {
          opacity: 1;
        }
  }

._toolCell_uazmk_724 {
  text-align: right;
}

._toolCell_uazmk_724 button {
    margin: auto;
    display: block;
  }

._tableColumnEditorTrigger_uazmk_743 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  padding: var(--spacing-1);
  color: var(--baseTextContrast);
  padding: var(--spacing-1);
  border-radius: var(--radius-full);
  opacity: 0.2;
}

._tableColumnEditorTrigger_uazmk_743 svg {
    display: block;
  }

@media (hover: hover) {
    ._tableColumnEditorTrigger_uazmk_743:hover {
      background-color: var(--baseBg);
    }
  }

._tableColumnEditorTrigger_uazmk_743:active svg {
    transform: translate(1px, 1px);
  }

._tableColumnEditorTrigger_uazmk_743[data-state=on],
  ._tableColumnEditorTrigger_uazmk_743:active {
    background-color: var(--baseBg);
    color: var(--baseTextContrast);
  }

._tableColumnEditorTrigger_uazmk_743[data-active=true] {
    opacity: 1 !important;
  }

._tableColumnEditorToolbar_uazmk_789 {
  display: flex;
}

._tableColumnEditorToolbar_uazmk_789>button {
    border: 0;
    background-color: transparent;
    font-size: inherit;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    all: unset;
    box-sizing: border-box;
    cursor: default;
    padding: var(--spacing-1);
    color: var(--baseTextContrast);
  }

._tableColumnEditorToolbar_uazmk_789>button svg {
    display: block;
  }

@media (hover: hover) {
    ._tableColumnEditorToolbar_uazmk_789>button:hover {
      background-color: var(--baseBg);
    }
  }

._tableColumnEditorToolbar_uazmk_789>button:active svg {
    transform: translate(1px, 1px);
  }

._tableColumnEditorToolbar_uazmk_789>button[data-state=on],
  ._tableColumnEditorToolbar_uazmk_789>button:active {
    background-color: var(--baseBg);
    color: var(--baseTextContrast);
  }

._tableColumnEditorToolbar_uazmk_789 [role=separator] {
    margin-left: var(--spacing-1);
    margin-right: var(--spacing-1);
  }


._toggleGroupRoot_uazmk_803 {
  display: inline-flex;
}


._toggleGroupRoot_uazmk_803 button {
    border: 0;
    background-color: transparent;
    font-size: inherit;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    all: unset;
    box-sizing: border-box;
    cursor: default;
    padding: var(--spacing-1);
    color: var(--baseTextContrast);
  }


._toggleGroupRoot_uazmk_803 button svg {
    display: block;
  }


@media (hover: hover) {
    ._toggleGroupRoot_uazmk_803 button:hover {
      background-color: var(--baseBg);
    }
  }


._toggleGroupRoot_uazmk_803 button:active svg {
    transform: translate(1px, 1px);
  }


._toggleGroupRoot_uazmk_803 button[data-state=on],
  ._toggleGroupRoot_uazmk_803 button:active {
    background-color: var(--baseBg);
    color: var(--baseTextContrast);
  }


._toggleGroupRoot_uazmk_803 button:first-child {
      border-top-left-radius: var(--radius-base);
      border-bottom-left-radius: var(--radius-base);
    }


._toggleGroupRoot_uazmk_803 button:last-child {
      border-top-right-radius: var(--radius-base);
      border-bottom-right-radius: var(--radius-base);
    }

._tableToolsColumn_uazmk_821 {
  width: 2rem;
}

._tableToolsColumn_uazmk_821 button {
    margin: auto;
    display: block;
  }

._leftAlignedCell_uazmk_830 {
  text-align: left;
}

._rightAlignedCell_uazmk_834 {
  text-align: right;
}

._centeredCell_uazmk_838 {
  text-align: center;
}

._addColumnButton_uazmk_746,
._addRowButton_uazmk_745 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  padding: var(--spacing-1);
  color: var(--baseTextContrast);
  background-color: var(--baseBase);

  display: flex;
  align-items: center;
}

._addColumnButton_uazmk_746 svg, ._addRowButton_uazmk_745 svg {
    display: block;
  }

@media (hover: hover) {
    ._addColumnButton_uazmk_746:hover, ._addRowButton_uazmk_745:hover {
      background-color: var(--baseBg);
    }
  }

._addColumnButton_uazmk_746:active svg, ._addRowButton_uazmk_745:active svg {
    transform: translate(1px, 1px);
  }

._addColumnButton_uazmk_746[data-state=on],
  ._addRowButton_uazmk_745[data-state=on],
  ._addColumnButton_uazmk_746:active,
  ._addRowButton_uazmk_745:active {
    background-color: var(--baseBg);
    color: var(--baseTextContrast);
  }

._addColumnButton_uazmk_746 svg, ._addRowButton_uazmk_745 svg {
    margin: auto;
  }

._addRowButton_uazmk_745 {
  width: 100%;
  margin-top: var(--spacing-px);
  box-sizing: border-box;
  border-bottom-right-radius: var(--radius-medium);
  border-bottom-left-radius: var(--radius-medium);
}

._addColumnButton_uazmk_746 {
  margin-left: var(--spacing-px);
  height: 100%;
  border-top-right-radius: var(--radius-medium);
  border-bottom-right-radius: var(--radius-medium);
}

/** Dialog */
._dialogOverlay_uazmk_871 {
  position: fixed;
  inset: 0;
  animation: _overlayShow_uazmk_1 150ms cubic-bezier(0.16, 1, 0.3, 1);
  background-color: var(--baseBase);
  z-index: 51;
  opacity: 0.5;
}

._dialogContent_uazmk_602,
._largeDialogContent_uazmk_614 {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: _contentShow_uazmk_1 150ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 52;
}

._dialogContent_uazmk_602:focus,
._largeDialogContent_uazmk_614:focus {
  outline: none;
}


@keyframes _overlayShow_uazmk_1 {
  from {
    opacity: 0;
  }

  to {
    opacity: .5;
  }
}

@keyframes _contentShow_uazmk_1 {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

._focusedImage_uazmk_918 {
  outline: highlight solid 2px;
}

._imageWrapper_uazmk_922 {
  display: inline-block;
  position: relative;
}

._imageWrapper_uazmk_922[draggable=true] {
  cursor: move;
  /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -webkit-grab;
}

._editImageToolbar_uazmk_935 {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-1);
  z-index: 1;
  background-color: var(--baseBase);
  border-bottom-left-radius: var(--radius-base);
}

._editImageButton_uazmk_939 svg {
    display: block;
  }

._inlineEditor_uazmk_945 {
  display: inline-flex;
  border-radius: var(--radius-medium);
  padding: var(--spacing-1);
  gap: var(--spacing-2);
  align-items: center;
  background: var(--baseBg);
}

._blockEditor_uazmk_954 {
  display: flex;
  justify-content: stretch;
  border-radius: var(--radius-medium);
  padding: var(--spacing-2);
  gap: var(--spacing-2);
  align-items: center;
  background: var(--baseBg);
}

._blockEditor_uazmk_954 ._nestedEditor_uazmk_963 {
    flex-grow: 1;
  }

._nestedEditor_uazmk_963 {
  background: var(--basePageBg);
  padding: var(--spacing-1) var(--spacing-2);
  border-radius: var(--radius-medium);
}

._nestedEditor_uazmk_963>p {
    margin: 0;
  }

._nestedEditor_uazmk_963:focus {
    outline: none;
  }

._genericComponentName_uazmk_982 {
  font-size: var(--text-sm);
  color: var(--baseText);
  padding-right: var(--spacing-2);
}

._diffSourceToggle_uazmk_988 {
  border-radius: var(--radius-medium);
  display: flex;
}

._diffSourceToggle_uazmk_988 ._toolbarToggleItem_uazmk_206 {
    padding: 0;
  }

._diffSourceToggle_uazmk_988 ._toolbarToggleItem_uazmk_206>span {
      display: block;
      padding: var(--spacing-1) var(--spacing-1);
    }

._selectWithLabel_uazmk_1002 {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-left: var(--spacing-2);
}

._selectWithLabel_uazmk_1002>label {
    font-size: var(--text-sm);
  }

._selectWithLabel_uazmk_1002 ._selectTrigger_uazmk_307 {
    border: 1px solid var(--baseBorder);
  }

._toolbarTitleMode_uazmk_1017 {
  font-size: var(--text-sm);
  margin-left: var(--spacing-2);
}


._imageControlWrapperResizing_uazmk_1023 {
  touch-action: none;
}

._imageResizer_uazmk_1027 {
  display: block;
  width: 7px;
  height: 7px;
  position: absolute;
  background-color: var(--accentText);
  border: 1px solid var(--baseBg);
}

._imageResizer_uazmk_1027._imageResizerN_uazmk_1036 {
  top: -6px;
  left: 48%;
  cursor: n-resize;
}

._imageResizer_uazmk_1027._imageResizerNe_uazmk_1042 {
  top: -6px;
  right: -6px;
  cursor: ne-resize;
}

._imageResizer_uazmk_1027._imageResizerE_uazmk_1048 {
  bottom: 48%;
  right: -6px;
  cursor: e-resize;
}

._imageResizer_uazmk_1027._imageResizerSe_uazmk_1054 {
  bottom: -2px;
  right: -6px;
  cursor: nwse-resize;
}

._imageResizer_uazmk_1027._imageResizerS_uazmk_1054 {
  bottom: -2px;
  left: 48%;
  cursor: s-resize;
}

._imageResizer_uazmk_1027._imageResizerSw_uazmk_1066 {
  bottom: -2px;
  left: -6px;
  cursor: sw-resize;
}

._imageResizer_uazmk_1027._imageResizerW_uazmk_1072 {
  bottom: 48%;
  left: -6px;
  cursor: w-resize;
}

._imageResizer_uazmk_1027._imageResizerNw_uazmk_1078 {
  top: -6px;
  left: -6px;
  cursor: nw-resize;
}

._placeholder_uazmk_1084 {
  color: var(--baseSolid);
  overflow: hidden;
  position: absolute;
  top: 0;
  padding: var(--spacing-3);
  text-overflow: ellipsis;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  white-space: nowrap;
  display: inline-block;
  pointer-events: none;
}

._rootContentEditableWrapper_uazmk_1097 {
  position: relative;
}



._downshiftContainer_uazmk_1103 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

._downshiftInputWrapper_uazmk_1109 {
  display: flex;
  align-items: center;
  background-color: var(--baseBase);

  border-radius: var(--radius-base);
  border: 1px solid var(--baseBorder);
}

._downshiftInputWrapper_uazmk_1109[data-visible-dropdown=true] {
    border-bottom-left-radius: var(--radius-none);
    border-bottom-right-radius: var(--radius-none);
    border-bottom-width: 0;
  }

._downshiftInputWrapper_uazmk_1109>button {
    border: 0;
    background-color: transparent;
    font-size: inherit;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    all: unset;
    box-sizing: border-box;
    cursor: default;
    padding-right: var(--spacing-2);
  }

._downshiftInput_uazmk_1109 {
  border: 0;
  background-color: transparent;
  font-size: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  all: unset;
  box-sizing: border-box;
  cursor: default;
  width: 20rem;
  padding: var(--spacing-2) var(--spacing-3);
  font-size: var(--text-sm);
}

._downshiftInput_uazmk_1109::-moz-placeholder {
    color: var(--baseBorder);
  }

._downshiftInput_uazmk_1109::placeholder {
    color: var(--baseBorder);
  }

._downshiftAutocompleteContainer_uazmk_1140 {
  position: relative;
}

._downshiftAutocompleteContainer_uazmk_1140 ul {
    all: unset;
    box-sizing: border-box;
    position: absolute;
    font-size: var(--text-sm);
    width: 100%;
    display: none;
    border-bottom-left-radius: var(--radius-medium);
    border-bottom-right-radius: var(--radius-medium);
    max-height: var(--spacing-48);
    overflow-x: hidden;
    overflow-y: auto;
    border: 1px solid var(--baseBorder);
    border-top-width: 0;
    background-color: var(--baseBase);
  }

._downshiftAutocompleteContainer_uazmk_1140 ul[data-visible=true] {
      display: block;
    }

._downshiftAutocompleteContainer_uazmk_1140 ul li {
      padding: var(--spacing-2) var(--spacing-3);
      white-space: nowrap;
      margin-bottom: var(--spacing-1);
      overflow-x: hidden;
      text-overflow: ellipsis;
    }

._downshiftAutocompleteContainer_uazmk_1140 ul li[data-selected=true] {
        background-color: var(--baseBgSubtle);
      }

._downshiftAutocompleteContainer_uazmk_1140 ul li[data-highlighted=true] {
        background-color: var(--baseBgHover);
      }

._downshiftAutocompleteContainer_uazmk_1140 ul li:last-of-type {
        border-bottom-left-radius: var(--radius-medium);
        border-bottom-right-radius: var(--radius-medium);
      }

._textInput_uazmk_1186 {
  all: unset;
  border-radius: var(--radius-base);
  border: 1px solid var(--baseBorder);
  background-color: var(--baseBase);
  padding: var(--spacing-2) var(--spacing-3);
}

form._multiFieldForm_uazmk_1194 {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-2);
  gap: var(--spacing-2);
}

form._multiFieldForm_uazmk_1194 ._formField_uazmk_1200 {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
  }

form._multiFieldForm_uazmk_1194 ._formField_uazmk_1200 label {
      font-size: var(--text-xs);
    }

._markdownParseError_uazmk_1211 {
  border-radius: var(--radius-base);
  border: 1px solid var(--error-color);
  padding: var(--spacing-2);
  margin-block: var(--spacing-2);
  color: var(--error-color);
  font-size: var(--text-xs);
}

._popupContainer_uazmk_1220 {
  position: relative;
  z-index: 2;
}

._inputSizer_uazmk_1225 {
  display: inline-grid;
  vertical-align: baseline;
  align-items: center;
  position: relative;
}

._inputSizer_uazmk_1225::after,
  ._inputSizer_uazmk_1225 input {
    width: auto;
    min-width: 1rem;
    grid-area: 1 / 2;
    font: inherit;
    margin: 0;
    padding: 0 2px;
    resize: none;
    background: none;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    border: none;
    color: inherit;
  }

._inputSizer_uazmk_1225 span {
    padding: 0.25em;
  }

._inputSizer_uazmk_1225::after {
    content: attr(data-value);
    white-space: pre-wrap;
  }
:root, ._light_1tncs_1, ._light-theme_1tncs_1 {
  --blue-1: #fbfdff;
  --blue-2: #f4faff;
  --blue-3: #e6f4fe;
  --blue-4: #d5efff;
  --blue-5: #c2e5ff;
  --blue-6: #acd8fc;
  --blue-7: #8ec8f6;
  --blue-8: #5eb1ef;
  --blue-9: #0090ff;
  --blue-10: #0588f0;
  --blue-11: #0d74ce;
  --blue-12: #113264;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {
      --blue-1: color(display-p3 0.986 0.992 0.999);
      --blue-2: color(display-p3 0.96 0.979 0.998);
      --blue-3: color(display-p3 0.912 0.956 0.991);
      --blue-4: color(display-p3 0.853 0.932 1);
      --blue-5: color(display-p3 0.788 0.894 0.998);
      --blue-6: color(display-p3 0.709 0.843 0.976);
      --blue-7: color(display-p3 0.606 0.777 0.947);
      --blue-8: color(display-p3 0.451 0.688 0.917);
      --blue-9: color(display-p3 0.247 0.556 0.969);
      --blue-10: color(display-p3 0.234 0.523 0.912);
      --blue-11: color(display-p3 0.15 0.44 0.84);
      --blue-12: color(display-p3 0.102 0.193 0.379);
    }
  }
}

._dark_1tncs_1, ._dark-theme_1tncs_1 {
  --blue-1: #0d1520;
  --blue-2: #111927;
  --blue-3: #0d2847;
  --blue-4: #003362;
  --blue-5: #004074;
  --blue-6: #104d87;
  --blue-7: #205d9e;
  --blue-8: #2870bd;
  --blue-9: #0090ff;
  --blue-10: #3b9eff;
  --blue-11: #70b8ff;
  --blue-12: #c2e6ff;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    ._dark_1tncs_1, ._dark-theme_1tncs_1 {
      --blue-1: color(display-p3 0.057 0.081 0.122);
      --blue-2: color(display-p3 0.072 0.098 0.147);
      --blue-3: color(display-p3 0.078 0.154 0.27);
      --blue-4: color(display-p3 0.033 0.197 0.37);
      --blue-5: color(display-p3 0.08 0.245 0.441);
      --blue-6: color(display-p3 0.14 0.298 0.511);
      --blue-7: color(display-p3 0.195 0.361 0.6);
      --blue-8: color(display-p3 0.239 0.434 0.72);
      --blue-9: color(display-p3 0.247 0.556 0.969);
      --blue-10: color(display-p3 0.344 0.612 0.973);
      --blue-11: color(display-p3 0.49 0.72 1);
      --blue-12: color(display-p3 0.788 0.898 0.99);
    }
  }
}

:root, ._light_1tncs_1, ._light-theme_1tncs_1 {
  --slate-1: #fcfcfd;
  --slate-2: #f9f9fb;
  --slate-3: #f0f0f3;
  --slate-4: #e8e8ec;
  --slate-5: #e0e1e6;
  --slate-6: #d9d9e0;
  --slate-7: #cdced6;
  --slate-8: #b9bbc6;
  --slate-9: #8b8d98;
  --slate-10: #80838d;
  --slate-11: #60646c;
  --slate-12: #1c2024;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {
      --slate-1: color(display-p3 0.988 0.988 0.992);
      --slate-2: color(display-p3 0.976 0.976 0.984);
      --slate-3: color(display-p3 0.94 0.941 0.953);
      --slate-4: color(display-p3 0.908 0.909 0.925);
      --slate-5: color(display-p3 0.88 0.881 0.901);
      --slate-6: color(display-p3 0.85 0.852 0.876);
      --slate-7: color(display-p3 0.805 0.808 0.838);
      --slate-8: color(display-p3 0.727 0.733 0.773);
      --slate-9: color(display-p3 0.547 0.553 0.592);
      --slate-10: color(display-p3 0.503 0.512 0.549);
      --slate-11: color(display-p3 0.379 0.392 0.421);
      --slate-12: color(display-p3 0.113 0.125 0.14);
    }
  }
}

._dark_1tncs_1, ._dark-theme_1tncs_1 {
  --slate-1: #111113;
  --slate-2: #18191b;
  --slate-3: #212225;
  --slate-4: #272a2d;
  --slate-5: #2e3135;
  --slate-6: #363a3f;
  --slate-7: #43484e;
  --slate-8: #5a6169;
  --slate-9: #696e77;
  --slate-10: #777b84;
  --slate-11: #b0b4ba;
  --slate-12: #edeef0;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    ._dark_1tncs_1, ._dark-theme_1tncs_1 {
      --slate-1: color(display-p3 0.067 0.067 0.074);
      --slate-2: color(display-p3 0.095 0.098 0.105);
      --slate-3: color(display-p3 0.13 0.135 0.145);
      --slate-4: color(display-p3 0.156 0.163 0.176);
      --slate-5: color(display-p3 0.183 0.191 0.206);
      --slate-6: color(display-p3 0.215 0.226 0.244);
      --slate-7: color(display-p3 0.265 0.28 0.302);
      --slate-8: color(display-p3 0.357 0.381 0.409);
      --slate-9: color(display-p3 0.415 0.431 0.463);
      --slate-10: color(display-p3 0.469 0.483 0.514);
      --slate-11: color(display-p3 0.692 0.704 0.728);
      --slate-12: color(display-p3 0.93 0.933 0.94);
    }
  }
}

:root, ._light_1tncs_1, ._light-theme_1tncs_1 {
  --grass-1: #fbfefb;
  --grass-2: #f5fbf5;
  --grass-3: #e9f6e9;
  --grass-4: #daf1db;
  --grass-5: #c9e8ca;
  --grass-6: #b2ddb5;
  --grass-7: #94ce9a;
  --grass-8: #65ba74;
  --grass-9: #46a758;
  --grass-10: #3e9b4f;
  --grass-11: #2a7e3b;
  --grass-12: #203c25;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {
      --grass-1: color(display-p3 0.986 0.996 0.985);
      --grass-2: color(display-p3 0.966 0.983 0.964);
      --grass-3: color(display-p3 0.923 0.965 0.917);
      --grass-4: color(display-p3 0.872 0.94 0.865);
      --grass-5: color(display-p3 0.811 0.908 0.802);
      --grass-6: color(display-p3 0.733 0.864 0.724);
      --grass-7: color(display-p3 0.628 0.803 0.622);
      --grass-8: color(display-p3 0.477 0.72 0.482);
      --grass-9: color(display-p3 0.38 0.647 0.378);
      --grass-10: color(display-p3 0.344 0.598 0.342);
      --grass-11: color(display-p3 0.263 0.488 0.261);
      --grass-12: color(display-p3 0.151 0.233 0.153);
    }
  }
}

:root, ._light_1tncs_1, ._light-theme_1tncs_1 {
  --cyan-1: #fafdfe;
  --cyan-2: #f2fafb;
  --cyan-3: #def7f9;
  --cyan-4: #caf1f6;
  --cyan-5: #b5e9f0;
  --cyan-6: #9ddde7;
  --cyan-7: #7dcedc;
  --cyan-8: #3db9cf;
  --cyan-9: #00a2c7;
  --cyan-10: #0797b9;
  --cyan-11: #107d98;
  --cyan-12: #0d3c48;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {
      --cyan-1: color(display-p3 0.982 0.992 0.996);
      --cyan-2: color(display-p3 0.955 0.981 0.984);
      --cyan-3: color(display-p3 0.888 0.965 0.975);
      --cyan-4: color(display-p3 0.821 0.941 0.959);
      --cyan-5: color(display-p3 0.751 0.907 0.935);
      --cyan-6: color(display-p3 0.671 0.862 0.9);
      --cyan-7: color(display-p3 0.564 0.8 0.854);
      --cyan-8: color(display-p3 0.388 0.715 0.798);
      --cyan-9: color(display-p3 0.282 0.627 0.765);
      --cyan-10: color(display-p3 0.264 0.583 0.71);
      --cyan-11: color(display-p3 0.08 0.48 0.63);
      --cyan-12: color(display-p3 0.108 0.232 0.277);
    }
  }
}

:root, ._light_1tncs_1, ._light-theme_1tncs_1 {
  --amber-1: #fefdfb;
  --amber-2: #fefbe9;
  --amber-3: #fff7c2;
  --amber-4: #ffee9c;
  --amber-5: #fbe577;
  --amber-6: #f3d673;
  --amber-7: #e9c162;
  --amber-8: #e2a336;
  --amber-9: #ffc53d;
  --amber-10: #ffba18;
  --amber-11: #ab6400;
  --amber-12: #4f3422;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {
      --amber-1: color(display-p3 0.995 0.992 0.985);
      --amber-2: color(display-p3 0.994 0.986 0.921);
      --amber-3: color(display-p3 0.994 0.969 0.782);
      --amber-4: color(display-p3 0.989 0.937 0.65);
      --amber-5: color(display-p3 0.97 0.902 0.527);
      --amber-6: color(display-p3 0.936 0.844 0.506);
      --amber-7: color(display-p3 0.89 0.762 0.443);
      --amber-8: color(display-p3 0.85 0.65 0.3);
      --amber-9: color(display-p3 1 0.77 0.26);
      --amber-10: color(display-p3 0.959 0.741 0.274);
      --amber-11: color(display-p3 0.64 0.4 0);
      --amber-12: color(display-p3 0.294 0.208 0.145);
    }
  }
}

:root, ._light_1tncs_1, ._light-theme_1tncs_1 {
  --red-1: #fffcfc;
  --red-2: #fff7f7;
  --red-3: #feebec;
  --red-4: #ffdbdc;
  --red-5: #ffcdce;
  --red-6: #fdbdbe;
  --red-7: #f4a9aa;
  --red-8: #eb8e90;
  --red-9: #e5484d;
  --red-10: #dc3e42;
  --red-11: #ce2c31;
  --red-12: #641723;
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {
      --red-1: color(display-p3 0.998 0.989 0.988);
      --red-2: color(display-p3 0.995 0.971 0.971);
      --red-3: color(display-p3 0.985 0.925 0.925);
      --red-4: color(display-p3 0.999 0.866 0.866);
      --red-5: color(display-p3 0.984 0.812 0.811);
      --red-6: color(display-p3 0.955 0.751 0.749);
      --red-7: color(display-p3 0.915 0.675 0.672);
      --red-8: color(display-p3 0.872 0.575 0.572);
      --red-9: color(display-p3 0.83 0.329 0.324);
      --red-10: color(display-p3 0.798 0.294 0.285);
      --red-11: color(display-p3 0.744 0.234 0.222);
      --red-12: color(display-p3 0.36 0.115 0.143);
    }
  }
}

._bold_1tncs_10 {
  font-weight: bold;
}

._italic_1tncs_14 {
  font-style: italic;
}

._underline_1tncs_18 {
  text-decoration: underline;
}

._bold_1tncs_10 {
  font-weight: 700;
}

._italic_1tncs_14 {
  font-style: italic;
}

._underline_1tncs_18 {
  text-decoration: underline
}

._strikethrough_1tncs_34 {
  text-decoration: line-through
}

._underlineStrikethrough_1tncs_38 {
  text-decoration: underline line-through
}

._subscript_1tncs_42 {
  font-size: .8em;
  vertical-align: sub !important
}

._superscript_1tncs_47 {
  font-size: .8em;
  vertical-align: super
}

._code_1tncs_52 {
  background-color: var(--baseBg);
  padding: 1px .25rem;
  font-family: var(--font-mono);
  font-size: 94%
}

._nestedListItem_1tncs_59 {
  list-style: none;
  list-style-type: none;
}

._nestedListItem_1tncs_59:before,
._nestedListItem_1tncs_59:after {
  display: none;
}

._listitem_1tncs_69 {
  margin: var(--spacing-2) 0;
}

._listItemChecked_1tncs_73,
._listItemUnchecked_1tncs_74 {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  margin-inline-start: -1rem;
  padding-left: var(--spacing-6);
  padding-right: var(--spacing-6);
  list-style-type: none;
  outline: none;
}

._listItemChecked_1tncs_73 {
  text-decoration: line-through;
}

._listItemUnchecked_1tncs_74:before,
._listItemChecked_1tncs_73:before {
  content: '';
  width: var(--spacing-4);
  height: var(--spacing-4);
  top: 0;
  left: 0;
  cursor: pointer;
  display: block;
  background-size: cover;
  position: absolute;
}

._listItemUnchecked_1tncs_74[dir='rtl']:before,
._listItemChecked_1tncs_73[dir='rtl']:before {
  left: auto;
  right: 0;
}

._listItemUnchecked_1tncs_74:focus:before,
._listItemChecked_1tncs_73:focus:before {
  box-shadow: 0 0 0 2px var(--accentBgActive);
  border-radius: var(--radius-small);
}

._listItemUnchecked_1tncs_74:before {
  border: 1px solid var(--baseBorder);
  border-radius: var(--radius-small);
}

._listItemChecked_1tncs_73:before {
  border: 1px solid var(--accentBorder);
  border-radius: var(--radius-small);
  background-color: var(--accentSolid);
  background-repeat: no-repeat;
}

._listItemChecked_1tncs_73:after {
  content: '';
  cursor: pointer;
  border-color: var(--baseBase);
  border-style: solid;
  position: absolute;
  display: block;
  top: var(--spacing-0_5);
  width: var(--spacing-1);
  left: var(--spacing-1_5);
  right: var(--spacing-1_5);
  height: var(--spacing-2);
  transform: rotate(45deg);
  border-width: 0 var(--spacing-0_5) var(--spacing-0_5) 0;
}

._nestedListItem_1tncs_59 {
  list-style-type: none;
}

._nestedListItem_1tncs_59:before,
._nestedListItem_1tncs_59:after {
  display: none;
}

._admonitionDanger_1tncs_151,
._admonitionInfo_1tncs_152,
._admonitionNote_1tncs_153,
._admonitionTip_1tncs_154,
._admonitionCaution_1tncs_155 {
  padding: var(--spacing-2);
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
  border-left: 3px solid var(--admonitionBorder);
  background-color: var(--admonitionBg);
}

._admonitionInfo_1tncs_152 {
  --admonitionBorder: var(--admonitionInfoBorder);
  --admonitionBg: var(--admonitionInfoBg);
}

._admonitionTip_1tncs_154 {
  --admonitionBorder: var(--admonitionTipBorder);
  --admonitionBg: var(--admonitionTipBg);
}

._admonitionCaution_1tncs_155 {
  --admonitionBorder: var(--admonitionCautionBorder);
  --admonitionBg: var(--admonitionCautionBg);
}

._admonitionDanger_1tncs_151 {
  --admonitionBorder: var(--admonitionDangerBorder);
  --admonitionBg: var(--admonitionDangerBg);
}

._admonitionNote_1tncs_153 {
  --admonitionBorder: var(--admonitionNoteBorder);
  --admonitionBg: var(--admonitionNoteBg);
}

._mdxExpression_1tncs_188 {
  font-family: var(--font-mono);
  font-size: 84%;
  color: var(--accentText);
}

._mdxExpression_1tncs_188 input:focus-visible {
    outline: none;
  }
`, "",{"version":3,"sources":["webpack://./node_modules/@mdxeditor/editor/dist/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE;MACE,6CAA6C;MAC7C,4CAA4C;MAC5C,6CAA6C;MAC7C,yCAAyC;MACzC,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,8CAA8C;MAC9C,2CAA2C;MAC3C,8CAA8C;IAChD;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE;MACE,6CAA6C;MAC7C,6CAA6C;MAC7C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,2CAA2C;MAC3C,4CAA4C;MAC5C,6CAA6C;MAC7C,8CAA8C;MAC9C,wCAAwC;MACxC,6CAA6C;IAC/C;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,6CAA6C;MAC7C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,+CAA+C;MAC/C,+CAA+C;MAC/C,8CAA8C;IAChD;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,+CAA+C;MAC/C,+CAA+C;MAC/C,6CAA6C;IAC/C;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,6CAA6C;MAC7C,+CAA+C;MAC/C,+CAA+C;MAC/C,+CAA+C;IACjD;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE;MACE,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,2CAA2C;MAC3C,2CAA2C;MAC3C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,2CAA2C;MAC3C,8CAA8C;IAChD;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,6CAA6C;MAC7C,8CAA8C;MAC9C,6CAA6C;MAC7C,0CAA0C;MAC1C,wCAAwC;MACxC,+CAA+C;MAC/C,wCAAwC;MACxC,+CAA+C;IACjD;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE;MACE,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,2CAA2C;MAC3C,6CAA6C;MAC7C,6CAA6C;MAC7C,4CAA4C;IAC9C;EACF;AACF;;AAEA,iBAAiB;;AAEjB;IACI,gCAAgC;IAChC,gCAAgC;IAChC,4BAA4B;EAC9B;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,qBAAqB;EACvB;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,gBAAgB;EAClB;;AAEF;IACI,YAAY;EACd;;AAEF;MACM,yBAAyB;MACzB,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;IAChB;;AAEJ,iBAAiB;;AAEjB;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEF,iBAAiB;;AAEjB;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEF;IACI,uBAAuB;IACvB,0BAA0B;EAC5B;;AAEF;IACI,uBAAuB;EACzB;;AAEF;IACI,+BAA+B;EACjC;;AAEF;IACI,4BAA4B;EAC9B;AACF;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;EAC5B,oCAAoC;;EAEpC,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;;EAEnC,gCAAgC;EAChC,oCAAoC;;EAEpC,kCAAkC;EAClC,sCAAsC;;EAEtC,qCAAqC;EACrC,yCAAyC;;EAEzC,kCAAkC;EAClC,sCAAsC;;EAEtC,kCAAkC;EAClC,sCAAsC;;EAEtC,4BAA4B;;EAE5B,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,sCAAsC;EACtC,qBAAqB;;EAErB,+GAA+G;EAC/G,mJAAmJ;;EAEnJ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;;EAElB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,2BAA2B;;AAE3B;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;IACI,yCAAyC;IACzC,wCAAwC;IACxC,uCAAuC;IACvC,wBAAwB;EAC1B;;AAEF;IACI,8BAA8B;IAC9B,cAAc;EAChB;;AAEF;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;IACI,YAAY;EACd;;AAEF;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,+BAA+B;EAC/B,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;EACxC;;AAEF;;MAEM,mCAAmC;IACrC;;AAEJ;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;;EAGE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;;;EAGE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;IACI;MACE,qCAAqC;IACvC;EACF;;AAEF;IACI,8BAA8B;EAChC;;AAEF;;;;IAII,8BAA8B;IAC9B,qCAAqC;EACvC;;AAEF;IACI,oBAAoB;EACtB;;AAEF;MACM,6BAA6B;IAC/B;;AAEJ;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,gDAAgD;EAChD,UAAU;EACV,wBAAwB;EACxB,6CAA6C;EAC7C,8CAA8C;EAC9C,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;IACI,2CAA2C;EAC7C;;AAEF;;;EAGE,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,4CAA4C;EAC5C,sCAAsC;EACtC,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;IACI,gDAAgD;IAChD,8CAA8C;IAC9C,6CAA6C;EAC/C;;AAEF;EACE,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;IACI,+BAA+B;EACjC;;AAEF;IACI,8BAA8B;IAC9B,+BAA+B;EACjC;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,6CAA6C;IAC7C,8CAA8C;EAChD;;AAEF;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,8BAA8B;;EAE9B,yBAAyB;AAC3B;;AAEA;IACI,aAAa;EACf;;AAEF;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;IACI,gCAAgC;EAClC;;AAEF;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,0CAA0C;EAC5C;;AAEF;IACI,UAAU;EACZ;;AAEF;IACI,UAAU;EACZ;;AAEF;IACI,6BAA6B;IAC7B,8BAA8B;EAChC;;AAEF;IACI,eAAe;EACjB;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,0CAA0C;EAC1C,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;IACI;MACE,8BAA8B;IAChC;EACF;;AAEF;;IAEI,sBAAsB;EACxB;;AAEF;;EAEE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,0CAA0C;EAC1C,qCAAqC;EACrC,yCAAyC;EACzC,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;EAC/B;;AAEF;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;;EAEjC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;IACI,6CAA6C;IAC7C,8CAA8C;IAC9C,sBAAsB;EACxB;;AAEF;IACI,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,+BAA+B;EACjC;;AAEF;;EAEE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;IACI,wBAAwB;EAC1B;;AAEF;IACI,wBAAwB;EAC1B;;AAEF;EACE,eAAe;EACf,2BAA2B;EAC3B,WAAW;AACb;;AAEA;IACI,mBAAmB;EACrB;;AAEF;IACI,kBAAkB;EACpB;;AAEF;;;EAGE,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;EAC/B,mCAAmC;EACnC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;EACrC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,qCAAqC;EACrC,0CAA0C;EAC1C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;;EAErB,6BAA6B;AAC/B;;AAEA;IACI;MACE,8BAA8B;IAChC;EACF;;AAEF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;EACrB;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mCAAmC;EACnC,0CAA0C;EAC1C,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;IACI,qBAAqB;EACvB;;AAEF;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;IACI,cAAc;EAChB;;AAEF;IACI;MACE,+BAA+B;IACjC;EACF;;AAEF;IACI,8BAA8B;EAChC;;AAEF;;IAEI,+BAA+B;IAC/B,8BAA8B;EAChC;;AAEF;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;IACI;MACE,yCAAyC;MACzC,sBAAsB;IACxB;EACF;;AAEF;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;EACnB;;AAEF;;IAEI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;EACrB;;AAEF;MACM,aAAa;IACf;;AAEJ;QACQ,SAAS;MACX;;AAEN;MACM,mCAAmC;IACrC;;AAEJ;;;;;IAKI,YAAY;EACd;;AAEF;;MAEM;;;;;QAKE,YAAY;MACd;;QAEE;UACE,UAAU;QACZ;EACN;;AAEF;EACE,iBAAiB;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;EAChB;;AAEF;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,YAAY;AACd;;AAEA;IACI,cAAc;EAChB;;AAEF;IACI;MACE,+BAA+B;IACjC;EACF;;AAEF;IACI,8BAA8B;EAChC;;AAEF;;IAEI,+BAA+B;IAC/B,8BAA8B;EAChC;;AAEF;IACI,qBAAqB;EACvB;;AAEF;EACE,aAAa;AACf;;AAEA;IACI,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,8BAA8B;EAChC;;AAEF;IACI,cAAc;EAChB;;AAEF;IACI;MACE,+BAA+B;IACjC;EACF;;AAEF;IACI,8BAA8B;EAChC;;AAEF;;IAEI,+BAA+B;IAC/B,8BAA8B;EAChC;;AAEF;IACI,6BAA6B;IAC7B,8BAA8B;EAChC;;;AAGF;EACE,oBAAoB;AACtB;;;AAGA;IACI,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,8BAA8B;EAChC;;;AAGF;IACI,cAAc;EAChB;;;AAGF;IACI;MACE,+BAA+B;IACjC;EACF;;;AAGF;IACI,8BAA8B;EAChC;;;AAGF;;IAEI,+BAA+B;IAC/B,8BAA8B;EAChC;;;AAGF;MACM,0CAA0C;MAC1C,6CAA6C;IAC/C;;;AAGJ;MACM,2CAA2C;MAC3C,8CAA8C;IAChD;;AAEJ;EACE,WAAW;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;EAChB;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;;EAEjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;IACI,cAAc;EAChB;;AAEF;IACI;MACE,+BAA+B;IACjC;EACF;;AAEF;IACI,8BAA8B;EAChC;;AAEF;;;;IAII,+BAA+B;IAC/B,8BAA8B;EAChC;;AAEF;IACI,YAAY;EACd;;AAEF;EACE,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;EACtB,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,mEAAmE;EACnE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mEAAmE;EACnE,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;;AAGA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;IACI,cAAc;EAChB;;AAEF;EACE,oBAAoB;EACpB,mCAAmC;EACnC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mCAAmC;EACnC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;IACI,YAAY;EACd;;AAEF;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;IACI,SAAS;EACX;;AAEF;IACI,aAAa;EACf;;AAEF;EACE,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,aAAa;AACf;;AAEA;IACI,UAAU;EACZ;;AAEF;MACM,cAAc;MACd,0CAA0C;IAC5C;;AAEJ;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;IACI,yBAAyB;EAC3B;;AAEF;IACI,mCAAmC;EACrC;;AAEF;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;;EAEjC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;IACI,6CAA6C;IAC7C,8CAA8C;IAC9C,sBAAsB;EACxB;;AAEF;IACI,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,+BAA+B;EACjC;;AAEF;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;IACI,wBAAwB;EAC1B;;AAEF;IACI,wBAAwB;EAC1B;;AAEF;EACE,kBAAkB;AACpB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,+CAA+C;IAC/C,gDAAgD;IAChD,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;IACnB,iCAAiC;EACnC;;AAEF;MACM,cAAc;IAChB;;AAEJ;MACM,0CAA0C;MAC1C,mBAAmB;MACnB,+BAA+B;MAC/B,kBAAkB;MAClB,uBAAuB;IACzB;;AAEJ;QACQ,qCAAqC;MACvC;;AAEN;QACQ,oCAAoC;MACtC;;AAEN;QACQ,+CAA+C;QAC/C,gDAAgD;MAClD;;AAEN;EACE,UAAU;EACV,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;AAEF;MACM,yBAAyB;IAC3B;;AAEJ;EACE,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,YAAY;IACZ,cAAc;EAChB;;AAEF;IACI,eAAe;EACjB;;AAEF;IACI,yBAAyB;IACzB,qBAAqB;EACvB;AACF;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE;MACE,6CAA6C;MAC7C,4CAA4C;MAC5C,6CAA6C;MAC7C,yCAAyC;MACzC,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,8CAA8C;MAC9C,2CAA2C;MAC3C,8CAA8C;IAChD;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE;MACE,6CAA6C;MAC7C,6CAA6C;MAC7C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,2CAA2C;MAC3C,4CAA4C;MAC5C,6CAA6C;MAC7C,8CAA8C;MAC9C,wCAAwC;MACxC,6CAA6C;IAC/C;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,6CAA6C;MAC7C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,+CAA+C;MAC/C,+CAA+C;MAC/C,8CAA8C;IAChD;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,+CAA+C;MAC/C,+CAA+C;MAC/C,6CAA6C;IAC/C;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,6CAA6C;MAC7C,+CAA+C;MAC/C,+CAA+C;MAC/C,+CAA+C;IACjD;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE;MACE,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,2CAA2C;MAC3C,2CAA2C;MAC3C,6CAA6C;MAC7C,6CAA6C;MAC7C,6CAA6C;MAC7C,2CAA2C;MAC3C,8CAA8C;IAChD;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE;MACE,8CAA8C;MAC9C,8CAA8C;MAC9C,8CAA8C;MAC9C,6CAA6C;MAC7C,6CAA6C;MAC7C,8CAA8C;MAC9C,6CAA6C;MAC7C,0CAA0C;MAC1C,wCAAwC;MACxC,+CAA+C;MAC/C,wCAAwC;MACxC,+CAA+C;IACjD;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE;MACE,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,4CAA4C;MAC5C,2CAA2C;MAC3C,6CAA6C;MAC7C,6CAA6C;MAC7C,4CAA4C;IAC9C;EACF;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,MAAM;EACN,OAAO;EACP,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,QAAQ;AACV;;AAEA;;EAEE,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;EAKE,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;IACI,aAAa;EACf","sourcesContent":[":root, .light, .light-theme {\n  --blue-1: #fbfdff;\n  --blue-2: #f4faff;\n  --blue-3: #e6f4fe;\n  --blue-4: #d5efff;\n  --blue-5: #c2e5ff;\n  --blue-6: #acd8fc;\n  --blue-7: #8ec8f6;\n  --blue-8: #5eb1ef;\n  --blue-9: #0090ff;\n  --blue-10: #0588f0;\n  --blue-11: #0d74ce;\n  --blue-12: #113264;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --blue-1: color(display-p3 0.986 0.992 0.999);\n      --blue-2: color(display-p3 0.96 0.979 0.998);\n      --blue-3: color(display-p3 0.912 0.956 0.991);\n      --blue-4: color(display-p3 0.853 0.932 1);\n      --blue-5: color(display-p3 0.788 0.894 0.998);\n      --blue-6: color(display-p3 0.709 0.843 0.976);\n      --blue-7: color(display-p3 0.606 0.777 0.947);\n      --blue-8: color(display-p3 0.451 0.688 0.917);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.234 0.523 0.912);\n      --blue-11: color(display-p3 0.15 0.44 0.84);\n      --blue-12: color(display-p3 0.102 0.193 0.379);\n    }\n  }\n}\n\n.dark, .dark-theme {\n  --blue-1: #0d1520;\n  --blue-2: #111927;\n  --blue-3: #0d2847;\n  --blue-4: #003362;\n  --blue-5: #004074;\n  --blue-6: #104d87;\n  --blue-7: #205d9e;\n  --blue-8: #2870bd;\n  --blue-9: #0090ff;\n  --blue-10: #3b9eff;\n  --blue-11: #70b8ff;\n  --blue-12: #c2e6ff;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    .dark, .dark-theme {\n      --blue-1: color(display-p3 0.057 0.081 0.122);\n      --blue-2: color(display-p3 0.072 0.098 0.147);\n      --blue-3: color(display-p3 0.078 0.154 0.27);\n      --blue-4: color(display-p3 0.033 0.197 0.37);\n      --blue-5: color(display-p3 0.08 0.245 0.441);\n      --blue-6: color(display-p3 0.14 0.298 0.511);\n      --blue-7: color(display-p3 0.195 0.361 0.6);\n      --blue-8: color(display-p3 0.239 0.434 0.72);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.344 0.612 0.973);\n      --blue-11: color(display-p3 0.49 0.72 1);\n      --blue-12: color(display-p3 0.788 0.898 0.99);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --slate-1: #fcfcfd;\n  --slate-2: #f9f9fb;\n  --slate-3: #f0f0f3;\n  --slate-4: #e8e8ec;\n  --slate-5: #e0e1e6;\n  --slate-6: #d9d9e0;\n  --slate-7: #cdced6;\n  --slate-8: #b9bbc6;\n  --slate-9: #8b8d98;\n  --slate-10: #80838d;\n  --slate-11: #60646c;\n  --slate-12: #1c2024;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --slate-1: color(display-p3 0.988 0.988 0.992);\n      --slate-2: color(display-p3 0.976 0.976 0.984);\n      --slate-3: color(display-p3 0.94 0.941 0.953);\n      --slate-4: color(display-p3 0.908 0.909 0.925);\n      --slate-5: color(display-p3 0.88 0.881 0.901);\n      --slate-6: color(display-p3 0.85 0.852 0.876);\n      --slate-7: color(display-p3 0.805 0.808 0.838);\n      --slate-8: color(display-p3 0.727 0.733 0.773);\n      --slate-9: color(display-p3 0.547 0.553 0.592);\n      --slate-10: color(display-p3 0.503 0.512 0.549);\n      --slate-11: color(display-p3 0.379 0.392 0.421);\n      --slate-12: color(display-p3 0.113 0.125 0.14);\n    }\n  }\n}\n\n.dark, .dark-theme {\n  --slate-1: #111113;\n  --slate-2: #18191b;\n  --slate-3: #212225;\n  --slate-4: #272a2d;\n  --slate-5: #2e3135;\n  --slate-6: #363a3f;\n  --slate-7: #43484e;\n  --slate-8: #5a6169;\n  --slate-9: #696e77;\n  --slate-10: #777b84;\n  --slate-11: #b0b4ba;\n  --slate-12: #edeef0;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    .dark, .dark-theme {\n      --slate-1: color(display-p3 0.067 0.067 0.074);\n      --slate-2: color(display-p3 0.095 0.098 0.105);\n      --slate-3: color(display-p3 0.13 0.135 0.145);\n      --slate-4: color(display-p3 0.156 0.163 0.176);\n      --slate-5: color(display-p3 0.183 0.191 0.206);\n      --slate-6: color(display-p3 0.215 0.226 0.244);\n      --slate-7: color(display-p3 0.265 0.28 0.302);\n      --slate-8: color(display-p3 0.357 0.381 0.409);\n      --slate-9: color(display-p3 0.415 0.431 0.463);\n      --slate-10: color(display-p3 0.469 0.483 0.514);\n      --slate-11: color(display-p3 0.692 0.704 0.728);\n      --slate-12: color(display-p3 0.93 0.933 0.94);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --grass-1: #fbfefb;\n  --grass-2: #f5fbf5;\n  --grass-3: #e9f6e9;\n  --grass-4: #daf1db;\n  --grass-5: #c9e8ca;\n  --grass-6: #b2ddb5;\n  --grass-7: #94ce9a;\n  --grass-8: #65ba74;\n  --grass-9: #46a758;\n  --grass-10: #3e9b4f;\n  --grass-11: #2a7e3b;\n  --grass-12: #203c25;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --grass-1: color(display-p3 0.986 0.996 0.985);\n      --grass-2: color(display-p3 0.966 0.983 0.964);\n      --grass-3: color(display-p3 0.923 0.965 0.917);\n      --grass-4: color(display-p3 0.872 0.94 0.865);\n      --grass-5: color(display-p3 0.811 0.908 0.802);\n      --grass-6: color(display-p3 0.733 0.864 0.724);\n      --grass-7: color(display-p3 0.628 0.803 0.622);\n      --grass-8: color(display-p3 0.477 0.72 0.482);\n      --grass-9: color(display-p3 0.38 0.647 0.378);\n      --grass-10: color(display-p3 0.344 0.598 0.342);\n      --grass-11: color(display-p3 0.263 0.488 0.261);\n      --grass-12: color(display-p3 0.151 0.233 0.153);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --cyan-1: #fafdfe;\n  --cyan-2: #f2fafb;\n  --cyan-3: #def7f9;\n  --cyan-4: #caf1f6;\n  --cyan-5: #b5e9f0;\n  --cyan-6: #9ddde7;\n  --cyan-7: #7dcedc;\n  --cyan-8: #3db9cf;\n  --cyan-9: #00a2c7;\n  --cyan-10: #0797b9;\n  --cyan-11: #107d98;\n  --cyan-12: #0d3c48;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --cyan-1: color(display-p3 0.982 0.992 0.996);\n      --cyan-2: color(display-p3 0.955 0.981 0.984);\n      --cyan-3: color(display-p3 0.888 0.965 0.975);\n      --cyan-4: color(display-p3 0.821 0.941 0.959);\n      --cyan-5: color(display-p3 0.751 0.907 0.935);\n      --cyan-6: color(display-p3 0.671 0.862 0.9);\n      --cyan-7: color(display-p3 0.564 0.8 0.854);\n      --cyan-8: color(display-p3 0.388 0.715 0.798);\n      --cyan-9: color(display-p3 0.282 0.627 0.765);\n      --cyan-10: color(display-p3 0.264 0.583 0.71);\n      --cyan-11: color(display-p3 0.08 0.48 0.63);\n      --cyan-12: color(display-p3 0.108 0.232 0.277);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --amber-1: #fefdfb;\n  --amber-2: #fefbe9;\n  --amber-3: #fff7c2;\n  --amber-4: #ffee9c;\n  --amber-5: #fbe577;\n  --amber-6: #f3d673;\n  --amber-7: #e9c162;\n  --amber-8: #e2a336;\n  --amber-9: #ffc53d;\n  --amber-10: #ffba18;\n  --amber-11: #ab6400;\n  --amber-12: #4f3422;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --amber-1: color(display-p3 0.995 0.992 0.985);\n      --amber-2: color(display-p3 0.994 0.986 0.921);\n      --amber-3: color(display-p3 0.994 0.969 0.782);\n      --amber-4: color(display-p3 0.989 0.937 0.65);\n      --amber-5: color(display-p3 0.97 0.902 0.527);\n      --amber-6: color(display-p3 0.936 0.844 0.506);\n      --amber-7: color(display-p3 0.89 0.762 0.443);\n      --amber-8: color(display-p3 0.85 0.65 0.3);\n      --amber-9: color(display-p3 1 0.77 0.26);\n      --amber-10: color(display-p3 0.959 0.741 0.274);\n      --amber-11: color(display-p3 0.64 0.4 0);\n      --amber-12: color(display-p3 0.294 0.208 0.145);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --red-1: #fffcfc;\n  --red-2: #fff7f7;\n  --red-3: #feebec;\n  --red-4: #ffdbdc;\n  --red-5: #ffcdce;\n  --red-6: #fdbdbe;\n  --red-7: #f4a9aa;\n  --red-8: #eb8e90;\n  --red-9: #e5484d;\n  --red-10: #dc3e42;\n  --red-11: #ce2c31;\n  --red-12: #641723;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --red-1: color(display-p3 0.998 0.989 0.988);\n      --red-2: color(display-p3 0.995 0.971 0.971);\n      --red-3: color(display-p3 0.985 0.925 0.925);\n      --red-4: color(display-p3 0.999 0.866 0.866);\n      --red-5: color(display-p3 0.984 0.812 0.811);\n      --red-6: color(display-p3 0.955 0.751 0.749);\n      --red-7: color(display-p3 0.915 0.675 0.672);\n      --red-8: color(display-p3 0.872 0.575 0.572);\n      --red-9: color(display-p3 0.83 0.329 0.324);\n      --red-10: color(display-p3 0.798 0.294 0.285);\n      --red-11: color(display-p3 0.744 0.234 0.222);\n      --red-12: color(display-p3 0.36 0.115 0.143);\n    }\n  }\n}\n\n/** Code mirror */\n\n.mdxeditor .cm-editor {\n    --sp-font-mono: var(--font-mono);\n    --sp-font-body: var(--font-body);\n    padding: var(--sp-space-4) 0;\n  }\n\n.mdxeditor .sp-editor .cm-editor {\n    padding-bottom: 0;\n  }\n\n.mdxeditor .cm-scroller {\n    padding: 0 !important;\n  }\n\n.mdxeditor .cm-focused {\n    outline: none;\n  }\n\n.mdxeditor .sp-wrapper {\n    overflow: hidden;\n  }\n\n.mdxeditor .sp-layout {\n    border: none;\n  }\n\n.mdxeditor .sp-cm pre {\n      white-space: break-spaces;\n      word-break: break-word;\n      overflow-wrap: anywhere;\n      flex-shrink: 1;\n    }\n\n/** Diff viewer */\n\n.mdxeditor .cm-mergeView .cm-scroller {\n    font-family: var(--font-mono);\n    line-height: 1.3rem;\n    font-size: var(--text-xs);\n  }\n\n/** Diff viewer */\n\n.mdxeditor .cm-sourceView .cm-scroller {\n    font-family: var(--font-mono);\n    line-height: 1.3rem;\n    font-size: var(--text-xs);\n  }\n\n.mdxeditor .cm-gutters {\n    background: transparent;\n    font-size: var(--text-xxs);\n  }\n\n.mdxeditor .cm-activeLine {\n    background: transparent;\n  }\n\n.mdxeditor .cm-tooltip-autocomplete {\n    background: var(--baseBgSubtle);\n  }\n\n.mdxeditor hr.selected[data-lexical-decorator=true] {\n    outline: 2px solid highlight;\n  }\n._editorRoot_uazmk_53 {\n  --accentBase: var(--blue-1);\n  --accentBgSubtle: var(--blue-2);\n  --accentBg: var(--blue-3);\n  --accentBgHover: var(--blue-4);\n  --accentBgActive: var(--blue-5);\n  --accentLine: var(--blue-6);\n  --accentBorder: var(--blue-7);\n  --accentBorderHover: var(--blue-8);\n  --accentSolid: var(--blue-9);\n  --accentSolidHover: var(--blue-10);\n  --accentText: var(--blue-11);\n  --accentTextContrast: var(--blue-12);\n\n  --basePageBg: white;\n  --baseBase: var(--slate-1);\n  --baseBgSubtle: var(--slate-2);\n  --baseBg: var(--slate-3);\n  --baseBgHover: var(--slate-4);\n  --baseBgActive: var(--slate-5);\n  --baseLine: var(--slate-6);\n  --baseBorder: var(--slate-7);\n  --baseBorderHover: var(--slate-8);\n  --baseSolid: var(--slate-9);\n  --baseSolidHover: var(--slate-10);\n  --baseText: var(--slate-11);\n  --baseTextContrast: var(--slate-12);\n\n  --admonitionTipBg: var(--cyan-4);\n  --admonitionTipBorder: var(--cyan-8);\n\n  --admonitionInfoBg: var(--grass-4);\n  --admonitionInfoBorder: var(--grass-8);\n\n  --admonitionCautionBg: var(--amber-4);\n  --admonitionCautionBorder: var(--amber-8);\n\n  --admonitionDangerBg: var(--red-4);\n  --admonitionDangerBorder: var(--red-8);\n\n  --admonitionNoteBg: var(--slate-4);\n  --admonitionNoteBorder: var(--slate-8);\n\n  --error-color: var(--red-10);\n\n  --spacing-0: 0px;\n  --spacing-px: 1px;\n  --spacing-0_5: 0.125rem;\n  --spacing-1: 0.25rem;\n  --spacing-1_5: 0.375rem;\n  --spacing-2: 0.5rem;\n  --spacing-2_5: 0.625rem;\n  --spacing-3: 0.75rem;\n  --spacing-3_5: 0.875rem;\n  --spacing-4: 1rem;\n  --spacing-5: 1.25rem;\n  --spacing-6: 1.5rem;\n  --spacing-7: 1.75rem;\n  --spacing-8: 2rem;\n  --spacing-9: 2.25rem;\n  --spacing-10: 2.5rem;\n  --spacing-11: 2.75rem;\n  --spacing-12: 3rem;\n  --spacing-14: 3.5rem;\n  --spacing-16: 4rem;\n  --spacing-20: 5rem;\n  --spacing-24: 6rem;\n  --spacing-28: 7rem;\n  --spacing-32: 8rem;\n  --spacing-36: 9rem;\n  --spacing-40: 10rem;\n  --spacing-44: 11rem;\n  --spacing-48: 12rem;\n  --spacing-52: 13rem;\n  --spacing-56: 14rem;\n  --spacing-60: 15rem;\n  --spacing-64: 16rem;\n  --spacing-72: 18rem;\n  --spacing-80: 20rem;\n  --spacing-96: 24rem;\n\n  --radius-none: 0px;\n  --radius-small: var(--spacing-0_5);\n  --radius-base: var(--spacing-1);\n  --radius-medium: var(--spacing-1_5);\n  --radius-large: var(--spacing-2);\n  --radius-extra-large: var(--spacing-3);\n  --radius-full: 9999px;\n\n  --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --font-body: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n\n  --text-base: 1rem;\n  --text-sm: 0.875rem;\n  --text-xs: 0.75rem;\n  --text-xxs: 0.6rem;\n\n  font-family: var(--font-body);\n  color: var(--baseText);\n}\n\n._editorWrapper_uazmk_154 {}\n\n._nestedListItem_uazmk_156 {\n  list-style: none;\n}\n\n._toolbarRoot_uazmk_160 {\n  z-index: 2;\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1);\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-1_5);\n  align-items: center;\n  overflow-x: auto;\n  position: sticky;\n  top: 0;\n  background-color: var(--baseBg);\n  width: inherit;\n}\n\n._toolbarRoot_uazmk_160 div[role=separator] {\n    margin: var(--spacing-2) var(--spacing-1);\n    border-left: 1px solid var(--baseBorder);\n    border-right: 1px solid var(--baseBase);\n    height: var(--spacing-4);\n  }\n\n._toolbarRoot_uazmk_160 svg {\n    color: var(--baseTextContrast);\n    display: block;\n  }\n\n._readOnlyToolbarRoot_uazmk_187 {\n  pointer-events: none;\n  background: var(--baseBase);\n}\n\n._readOnlyToolbarRoot_uazmk_187>div {\n    opacity: 0.5;\n  }\n\n._toolbarModeSwitch_uazmk_196 {\n  opacity: 1 !important;\n  margin-left: auto;\n  align-self: stretch;\n  align-items: stretch;\n  display: flex;\n  border: 1px solid var(--baseBg);\n  border-radius: var(--radius-medium);\n  font-size: var(--text-xs);\n}\n\n._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206 {\n    padding-inline-end: var(--spacing-4);\n    padding-inline-start: var(--spacing-4);\n  }\n\n._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206:active,\n    ._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206[data-state=on] {\n      background-color: var(--baseBorder);\n    }\n\n._toolbarGroupOfGroups_uazmk_217 {\n  display: flex;\n  margin: 0 var(--spacing-1);\n}\n\n._toolbarToggleSingleGroup_uazmk_222:first-of-type ._toolbarToggleItem_uazmk_206:only-child,\n._toolbarToggleSingleGroup_uazmk_222:only-child ._toolbarToggleItem_uazmk_206:first-child,\n._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206:first-child {\n  border-top-left-radius: var(--radius-base);\n  border-bottom-left-radius: var(--radius-base);\n}\n\n._toolbarToggleSingleGroup_uazmk_222:last-of-type ._toolbarToggleItem_uazmk_206:only-child,\n._toolbarToggleSingleGroup_uazmk_222:only-child ._toolbarToggleItem_uazmk_206:last-child,\n._toolbarModeSwitch_uazmk_196 ._toolbarToggleItem_uazmk_206:last-child {\n  border-top-right-radius: var(--radius-base);\n  border-bottom-right-radius: var(--radius-base);\n}\n\n._toolbarToggleItem_uazmk_206,\n._toolbarButton_uazmk_237 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-0_5);\n}\n\n@media (hover: hover) {\n    ._toolbarToggleItem_uazmk_206:hover, ._toolbarButton_uazmk_237:hover {\n      background-color: var(--baseBgActive);\n    }\n  }\n\n._toolbarToggleItem_uazmk_206:active svg, ._toolbarButton_uazmk_237:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._toolbarToggleItem_uazmk_206[data-state=on],\n  ._toolbarButton_uazmk_237[data-state=on],\n  ._toolbarToggleItem_uazmk_206:active,\n  ._toolbarButton_uazmk_237:active {\n    color: var(--baseTextContrast);\n    background-color: var(--baseBgActive);\n  }\n\n._toolbarToggleItem_uazmk_206[data-disabled], ._toolbarButton_uazmk_237[data-disabled] {\n    pointer-events: none;\n  }\n\n._toolbarToggleItem_uazmk_206[data-disabled] svg, ._toolbarButton_uazmk_237[data-disabled] svg {\n      color: var(--baseBorderHover);\n    }\n\n._toolbarButton_uazmk_237 {\n  border-radius: var(--radius-base);\n}\n\n._toolbarButton_uazmk_237 + ._toolbarButton_uazmk_237 {\n  margin-left: var(--spacing-1);\n}\n\n._activeToolbarButton_uazmk_274 {\n  color: var(--accentText);\n}\n\n._toolbarToggleSingleGroup_uazmk_222 {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n._toolbarNodeKindSelectContainer_uazmk_284,\n._toolbarButtonDropdownContainer_uazmk_285,\n._toolbarCodeBlockLanguageSelectContent_uazmk_286,\n._selectContainer_uazmk_287 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  z-index: 3;\n  width: var(--spacing-36);\n  border-bottom-left-radius: var(--radius-base);\n  border-bottom-right-radius: var(--radius-base);\n  background-color: var(--basePageBg);\n  font-size: var(--text-sm);\n}\n\n._toolbarButtonDropdownContainer_uazmk_285 {\n  border-top-right-radius: var(--radius-base);\n}\n\n._toolbarButtonDropdownContainer_uazmk_285 ._selectItem_uazmk_300:first-child {\n    border-top-right-radius: var(--radius-base);\n  }\n\n._toolbarNodeKindSelectTrigger_uazmk_305,\n._toolbarButtonSelectTrigger_uazmk_306,\n._selectTrigger_uazmk_307 {\n  border: 0;\n  background-color: transparent;\n  display: flex;\n  color: inherit;\n  align-items: center;\n  width: var(--spacing-36);\n  padding: var(--spacing-0_5) var(--spacing-1);\n  padding-inline-start: var(--spacing-2);\n  border-radius: var(--radius-medium);\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  font-size: var(--text-sm);\n  background-color: var(--basePageBg);\n  margin: 0 var(--spacing-1);\n}\n\n._toolbarNodeKindSelectTrigger_uazmk_305[data-state=open], ._toolbarButtonSelectTrigger_uazmk_306[data-state=open], ._selectTrigger_uazmk_307[data-state=open] {\n    filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n    border-bottom-right-radius: var(--radius-none);\n    border-bottom-left-radius: var(--radius-none);\n  }\n\n._selectTrigger_uazmk_307[data-placeholder]>span:first-child {\n  color: var(--baseBorderHover);\n}\n\n/** used in the sandpack */\n._toolbarButtonSelectTrigger_uazmk_306 {\n  width: auto;\n  padding-inline-start: var(--spacing-2);\n  padding-inline-end: var(--spacing-1);\n  padding-block: var(--spacing-0_5);\n}\n\n._toolbarCodeBlockLanguageSelectTrigger_uazmk_342,\n._toolbarCodeBlockLanguageSelectContent_uazmk_286 {\n  width: var(--spacing-48);\n}\n\n._toolbarNodeKindSelectItem_uazmk_347,\n._selectItem_uazmk_300 {\n  cursor: default;\n  display: flex;\n  padding: var(--spacing-2);\n}\n\n._toolbarNodeKindSelectItem_uazmk_347[data-highlighted], ._selectItem_uazmk_300[data-highlighted] {\n    background-color: var(--baseBg);\n  }\n\n._toolbarNodeKindSelectItem_uazmk_347[data-state=checked], ._selectItem_uazmk_300[data-state=checked] {\n    color: var(--baseTextContrast);\n    background-color: var(--baseBg);\n  }\n\n._toolbarNodeKindSelectItem_uazmk_347[data-highlighted], ._selectItem_uazmk_300[data-highlighted] {\n    outline: none;\n  }\n\n._toolbarNodeKindSelectItem_uazmk_347:last-child, ._selectItem_uazmk_300:last-child {\n    border-bottom-left-radius: var(--radius-base);\n    border-bottom-right-radius: var(--radius-base);\n  }\n\n._toolbarNodeKindSelectDropdownArrow_uazmk_372,\n._selectDropdownArrow_uazmk_373 {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n._contentEditable_uazmk_379 {\n  box-sizing: border-box;\n  width: 100%;\n  color: var(--baseTextContrast);\n\n  padding: var(--spacing-3);\n}\n\n._contentEditable_uazmk_379:focus {\n    outline: none;\n  }\n\n._codeMirrorWrapper_uazmk_391 {\n  margin-bottom: var(--spacing-5);\n  border: 1px solid var(--baseLine);\n  border-radius: var(--radius-medium);\n  overflow: hidden;\n  padding: 0.8rem;\n  position: relative;\n}\n\n._sandPackWrapper_uazmk_400 {\n  margin-bottom: var(--spacing-5);\n  border: 1px solid var(--baseLine);\n  border-radius: var(--radius-medium);\n  overflow: hidden;\n  position: relative;\n}\n\n._codeMirrorToolbar_uazmk_408 {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1);\n  z-index: 1;\n  background-color: var(--baseBase);\n  border-bottom-left-radius: var(--radius-base);\n}\n\n._frontmatterWrapper_uazmk_412 {\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-3);\n  background-color: var(--baseBgSubtle);\n}\n\n._frontmatterWrapper_uazmk_412[data-expanded=true] {\n    margin-bottom: var(--spacing-10);\n  }\n\n._frontmatterToggleButton_uazmk_422 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  font-size: var(--text-sm);\n}\n\n._propertyPanelTitle_uazmk_430 {\n  font-size: var(--text-xs);\n  font-weight: 400;\n  margin: 0;\n  padding-top: var(--spacing-2);\n  padding-left: var(--spacing-2);\n}\n\n._propertyEditorTable_uazmk_438 {\n  table-layout: fixed;\n  border-spacing: var(--spacing-2);\n}\n\n._propertyEditorTable_uazmk_438 th {\n    text-align: left;\n    font-size: var(--text-sm);\n    padding: var(--spacing-2) var(--spacing-3);\n  }\n\n._propertyEditorTable_uazmk_438 col:nth-child(1) {\n    width: 30%;\n  }\n\n._propertyEditorTable_uazmk_438 col:nth-child(2) {\n    width: 70%;\n  }\n\n._propertyEditorTable_uazmk_438 td:last-child ._iconButton_uazmk_456 {\n    margin-left: var(--spacing-4);\n    margin-right: var(--spacing-4);\n  }\n\n._propertyEditorTable_uazmk_438 ._readOnlyColumnCell_uazmk_461 {\n    padding-left: 0;\n  }\n\n._propertyEditorLabelCell_uazmk_466 {\n  font-weight: 400;\n}\n\n._readOnlyColumnCell_uazmk_461 {\n  padding-left: 0;\n}\n\n._buttonsFooter_uazmk_474 {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacing-2);\n}\n\n._propertyEditorInput_uazmk_480 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  width: 100%;\n  padding: var(--spacing-2) var(--spacing-3);\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseBase);\n  font-size: var(--text-sm);\n}\n\n._iconButton_uazmk_456 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  color: var(--baseText);\n}\n\n@media (hover: hover) {\n    ._iconButton_uazmk_456:hover {\n      color: var(--baseTextContrast);\n    }\n  }\n\n._iconButton_uazmk_456:disabled,\n  ._iconButton_uazmk_456:disabled:hover {\n    color: var(--baseLine);\n  }\n\n._primaryButton_uazmk_506,\n._secondaryButton_uazmk_507 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-2) var(--spacing-3);\n  border: 1px solid var(--accentBorder);\n  background-color: var(--accentSolidHover);\n  color: var(--baseBase);\n  font-size: var(--text-xs);\n  border-radius: var(--radius-medium);\n}\n\n._primaryButton_uazmk_506:disabled, ._secondaryButton_uazmk_507:disabled {\n    background: var(--accentLine);\n    border-color: var(--accentBg);\n  }\n\n._smallButton_uazmk_522 {\n  font-size: var(--text-xs);\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-base);\n}\n\n._secondaryButton_uazmk_507 {\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseSolidHover);\n  color: var(--baseBase);\n}\n\n._dialogForm_uazmk_534 {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2);\n}\n\n._linkDialogEditForm_uazmk_540 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-2);\n  padding: 0;\n}\n\n._linkDialogInputContainer_uazmk_548 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n._linkDialogInputWrapper_uazmk_554 {\n  display: flex;\n  align-items: center;\n  background-color: var(--baseBase);\n\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n}\n\n._linkDialogInputWrapper_uazmk_554[data-visible-dropdown=true] {\n    border-bottom-left-radius: var(--radius-none);\n    border-bottom-right-radius: var(--radius-none);\n    border-bottom-width: 0;\n  }\n\n._linkDialogInputWrapper_uazmk_554>button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding-right: var(--spacing-2);\n  }\n\n._linkDialogInput_uazmk_548,\n._dialogInput_uazmk_575 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  width: 20rem;\n  padding: var(--spacing-2) var(--spacing-3);\n  font-size: var(--text-sm);\n}\n\n._linkDialogInput_uazmk_548::-moz-placeholder, ._dialogInput_uazmk_575::-moz-placeholder {\n    color: var(--baseBorder);\n  }\n\n._linkDialogInput_uazmk_548::placeholder, ._dialogInput_uazmk_575::placeholder {\n    color: var(--baseBorder);\n  }\n\n._linkDialogAnchor_uazmk_586 {\n  position: fixed;\n  background-color: highlight;\n  z-index: -1;\n}\n\n._linkDialogAnchor_uazmk_586[data-visible=true] {\n    visibility: visible;\n  }\n\n._linkDialogAnchor_uazmk_586[data-visible=false] {\n    visibility: hidden;\n  }\n\n._linkDialogPopoverContent_uazmk_600,\n._tableColumnEditorPopoverContent_uazmk_601,\n._dialogContent_uazmk_602 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0_5);\n  border-radius: var(--radius-medium);\n  border: 1px solid var(--baseBg);\n  background-color: var(--basePageBg);\n  padding: var(--spacing-1) var(--spacing-1);\n  font-size: var(--text-sm);\n}\n\n._largeDialogContent_uazmk_614 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  gap: var(--spacing-0_5);\n  border-radius: var(--radius-medium);\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseBgSubtle);\n  padding: var(--spacing-4);\n  font-size: var(--text-sm);\n}\n\n._dialogTitle_uazmk_624 {\n  font-size: var(--text-base);\n  font-weight: 600;\n  padding-left: var(--spacing-2);\n}\n\n._dialogCloseButton_uazmk_630 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n._popoverContent_uazmk_637 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0_5);\n  border-radius: var(--radius-medium);\n  background-color: var(--baseBgSubtle);\n  padding: var(--spacing-2) var(--spacing-2);\n  font-size: var(--text-sm);\n  z-index: 1;\n}\n\n._popoverArrow_uazmk_649 {\n  fill: var(--basePageBg);\n}\n\n._linkDialogPreviewAnchor_uazmk_653 {\n  margin-right: var(--spacing-1);\n  display: flex;\n  align-items: center;\n  color: var(--accentText);\n  text-decoration: none;\n\n  border: 1px solid transparent;\n}\n\n@media (hover: hover) {\n    ._linkDialogPreviewAnchor_uazmk_653:hover {\n      color: var(--accentSolidHover);\n    }\n  }\n\n._linkDialogPreviewAnchor_uazmk_653 span {\n    max-width: 14rem;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n._tooltipTrigger_uazmk_676 {\n  align-self: center;\n}\n\n._tooltipContent_uazmk_680 {\n  z-index: 2;\n  position: relative;\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-1) var(--spacing-2);\n  font-size: var(--text-xs);\n  background-color: var(--baseText);\n  color: var(--baseBase);\n}\n\n._tooltipContent_uazmk_680 svg {\n    fill: var(--baseText);\n  }\n\n._actionButton_uazmk_694 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1);\n  color: var(--baseTextContrast);\n  padding: var(--spacing-1) var(--spacing-1);\n  border-radius: var(--radius-medium);\n  color: var(--baseTextContrast);\n}\n\n._actionButton_uazmk_694 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._actionButton_uazmk_694:hover {\n      background-color: var(--baseBg);\n    }\n  }\n\n._actionButton_uazmk_694:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._actionButton_uazmk_694[data-state=on],\n  ._actionButton_uazmk_694:active {\n    background-color: var(--baseBg);\n    color: var(--baseTextContrast);\n  }\n\n._primaryActionButton_uazmk_701 {\n  background-color: var(--accentSolid);\n  color: var(--baseBase);\n}\n\n@media (hover: hover) {\n    ._primaryActionButton_uazmk_701:hover {\n      background-color: var(--accentSolidHover);\n      color: var(--baseBase);\n    }\n  }\n\n._tableEditor_uazmk_713 {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n\n._tableEditor_uazmk_713 thead>tr>th {\n    text-align: right;\n  }\n\n._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),\n  ._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell=\"true\"]) {\n    border: 1px solid var(--baseBgActive);\n    padding: var(--spacing-1) var(--spacing-2);\n    white-space: normal;\n  }\n\n:is(._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell=\"true\"]))>div {\n      outline: none;\n    }\n\n:is(._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell=\"true\"]))>div>p {\n        margin: 0;\n      }\n\n[data-active=true]:is(._tableEditor_uazmk_713>tbody>tr>td:not(._toolCell_uazmk_724),._tableEditor_uazmk_713>tbody>tr>th:not(._toolCell_uazmk_724):not([data-tool-cell=\"true\"])) {\n      outline: solid 1px var(--baseSolid);\n    }\n\n._tableEditor_uazmk_713 ._tableColumnEditorTrigger_uazmk_743,\n  ._tableEditor_uazmk_713 ._tableRowEditorTrigger_uazmk_744,\n  ._tableEditor_uazmk_713 ._addRowButton_uazmk_745,\n  ._tableEditor_uazmk_713 ._addColumnButton_uazmk_746,\n  ._tableEditor_uazmk_713 ._iconButton_uazmk_456 {\n    opacity: .15;\n  }\n\n@media (hover: hover) {\n\n      ._tableEditor_uazmk_713:hover ._tableColumnEditorTrigger_uazmk_743,\n      ._tableEditor_uazmk_713:hover ._tableRowEditorTrigger_uazmk_744,\n      ._tableEditor_uazmk_713:hover ._addRowButton_uazmk_745,\n      ._tableEditor_uazmk_713:hover ._addColumnButton_uazmk_746,\n      ._tableEditor_uazmk_713:hover ._iconButton_uazmk_456 {\n        opacity: 0.3;\n      }\n\n        ._tableEditor_uazmk_713:hover ._tableColumnEditorTrigger_uazmk_743:hover, ._tableEditor_uazmk_713:hover ._tableRowEditorTrigger_uazmk_744:hover, ._tableEditor_uazmk_713:hover ._addRowButton_uazmk_745:hover, ._tableEditor_uazmk_713:hover ._addColumnButton_uazmk_746:hover, ._tableEditor_uazmk_713:hover ._iconButton_uazmk_456:hover {\n          opacity: 1;\n        }\n  }\n\n._toolCell_uazmk_724 {\n  text-align: right;\n}\n\n._toolCell_uazmk_724 button {\n    margin: auto;\n    display: block;\n  }\n\n._tableColumnEditorTrigger_uazmk_743 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1);\n  color: var(--baseTextContrast);\n  padding: var(--spacing-1);\n  border-radius: var(--radius-full);\n  opacity: 0.2;\n}\n\n._tableColumnEditorTrigger_uazmk_743 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._tableColumnEditorTrigger_uazmk_743:hover {\n      background-color: var(--baseBg);\n    }\n  }\n\n._tableColumnEditorTrigger_uazmk_743:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._tableColumnEditorTrigger_uazmk_743[data-state=on],\n  ._tableColumnEditorTrigger_uazmk_743:active {\n    background-color: var(--baseBg);\n    color: var(--baseTextContrast);\n  }\n\n._tableColumnEditorTrigger_uazmk_743[data-active=true] {\n    opacity: 1 !important;\n  }\n\n._tableColumnEditorToolbar_uazmk_789 {\n  display: flex;\n}\n\n._tableColumnEditorToolbar_uazmk_789>button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding: var(--spacing-1);\n    color: var(--baseTextContrast);\n  }\n\n._tableColumnEditorToolbar_uazmk_789>button svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._tableColumnEditorToolbar_uazmk_789>button:hover {\n      background-color: var(--baseBg);\n    }\n  }\n\n._tableColumnEditorToolbar_uazmk_789>button:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._tableColumnEditorToolbar_uazmk_789>button[data-state=on],\n  ._tableColumnEditorToolbar_uazmk_789>button:active {\n    background-color: var(--baseBg);\n    color: var(--baseTextContrast);\n  }\n\n._tableColumnEditorToolbar_uazmk_789 [role=separator] {\n    margin-left: var(--spacing-1);\n    margin-right: var(--spacing-1);\n  }\n\n\n._toggleGroupRoot_uazmk_803 {\n  display: inline-flex;\n}\n\n\n._toggleGroupRoot_uazmk_803 button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding: var(--spacing-1);\n    color: var(--baseTextContrast);\n  }\n\n\n._toggleGroupRoot_uazmk_803 button svg {\n    display: block;\n  }\n\n\n@media (hover: hover) {\n    ._toggleGroupRoot_uazmk_803 button:hover {\n      background-color: var(--baseBg);\n    }\n  }\n\n\n._toggleGroupRoot_uazmk_803 button:active svg {\n    transform: translate(1px, 1px);\n  }\n\n\n._toggleGroupRoot_uazmk_803 button[data-state=on],\n  ._toggleGroupRoot_uazmk_803 button:active {\n    background-color: var(--baseBg);\n    color: var(--baseTextContrast);\n  }\n\n\n._toggleGroupRoot_uazmk_803 button:first-child {\n      border-top-left-radius: var(--radius-base);\n      border-bottom-left-radius: var(--radius-base);\n    }\n\n\n._toggleGroupRoot_uazmk_803 button:last-child {\n      border-top-right-radius: var(--radius-base);\n      border-bottom-right-radius: var(--radius-base);\n    }\n\n._tableToolsColumn_uazmk_821 {\n  width: 2rem;\n}\n\n._tableToolsColumn_uazmk_821 button {\n    margin: auto;\n    display: block;\n  }\n\n._leftAlignedCell_uazmk_830 {\n  text-align: left;\n}\n\n._rightAlignedCell_uazmk_834 {\n  text-align: right;\n}\n\n._centeredCell_uazmk_838 {\n  text-align: center;\n}\n\n._addColumnButton_uazmk_746,\n._addRowButton_uazmk_745 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1);\n  color: var(--baseTextContrast);\n  background-color: var(--baseBase);\n\n  display: flex;\n  align-items: center;\n}\n\n._addColumnButton_uazmk_746 svg, ._addRowButton_uazmk_745 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._addColumnButton_uazmk_746:hover, ._addRowButton_uazmk_745:hover {\n      background-color: var(--baseBg);\n    }\n  }\n\n._addColumnButton_uazmk_746:active svg, ._addRowButton_uazmk_745:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._addColumnButton_uazmk_746[data-state=on],\n  ._addRowButton_uazmk_745[data-state=on],\n  ._addColumnButton_uazmk_746:active,\n  ._addRowButton_uazmk_745:active {\n    background-color: var(--baseBg);\n    color: var(--baseTextContrast);\n  }\n\n._addColumnButton_uazmk_746 svg, ._addRowButton_uazmk_745 svg {\n    margin: auto;\n  }\n\n._addRowButton_uazmk_745 {\n  width: 100%;\n  margin-top: var(--spacing-px);\n  box-sizing: border-box;\n  border-bottom-right-radius: var(--radius-medium);\n  border-bottom-left-radius: var(--radius-medium);\n}\n\n._addColumnButton_uazmk_746 {\n  margin-left: var(--spacing-px);\n  height: 100%;\n  border-top-right-radius: var(--radius-medium);\n  border-bottom-right-radius: var(--radius-medium);\n}\n\n/** Dialog */\n._dialogOverlay_uazmk_871 {\n  position: fixed;\n  inset: 0;\n  animation: _overlayShow_uazmk_1 150ms cubic-bezier(0.16, 1, 0.3, 1);\n  background-color: var(--baseBase);\n  z-index: 51;\n  opacity: 0.5;\n}\n\n._dialogContent_uazmk_602,\n._largeDialogContent_uazmk_614 {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: _contentShow_uazmk_1 150ms cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 52;\n}\n\n._dialogContent_uazmk_602:focus,\n._largeDialogContent_uazmk_614:focus {\n  outline: none;\n}\n\n\n@keyframes _overlayShow_uazmk_1 {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: .5;\n  }\n}\n\n@keyframes _contentShow_uazmk_1 {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%) scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n._focusedImage_uazmk_918 {\n  outline: highlight solid 2px;\n}\n\n._imageWrapper_uazmk_922 {\n  display: inline-block;\n  position: relative;\n}\n\n._imageWrapper_uazmk_922[draggable=true] {\n  cursor: move;\n  /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  cursor: -webkit-grab;\n}\n\n._editImageToolbar_uazmk_935 {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1);\n  z-index: 1;\n  background-color: var(--baseBase);\n  border-bottom-left-radius: var(--radius-base);\n}\n\n._editImageButton_uazmk_939 svg {\n    display: block;\n  }\n\n._inlineEditor_uazmk_945 {\n  display: inline-flex;\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-1);\n  gap: var(--spacing-2);\n  align-items: center;\n  background: var(--baseBg);\n}\n\n._blockEditor_uazmk_954 {\n  display: flex;\n  justify-content: stretch;\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-2);\n  gap: var(--spacing-2);\n  align-items: center;\n  background: var(--baseBg);\n}\n\n._blockEditor_uazmk_954 ._nestedEditor_uazmk_963 {\n    flex-grow: 1;\n  }\n\n._nestedEditor_uazmk_963 {\n  background: var(--basePageBg);\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-medium);\n}\n\n._nestedEditor_uazmk_963>p {\n    margin: 0;\n  }\n\n._nestedEditor_uazmk_963:focus {\n    outline: none;\n  }\n\n._genericComponentName_uazmk_982 {\n  font-size: var(--text-sm);\n  color: var(--baseText);\n  padding-right: var(--spacing-2);\n}\n\n._diffSourceToggle_uazmk_988 {\n  border-radius: var(--radius-medium);\n  display: flex;\n}\n\n._diffSourceToggle_uazmk_988 ._toolbarToggleItem_uazmk_206 {\n    padding: 0;\n  }\n\n._diffSourceToggle_uazmk_988 ._toolbarToggleItem_uazmk_206>span {\n      display: block;\n      padding: var(--spacing-1) var(--spacing-1);\n    }\n\n._selectWithLabel_uazmk_1002 {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  margin-left: var(--spacing-2);\n}\n\n._selectWithLabel_uazmk_1002>label {\n    font-size: var(--text-sm);\n  }\n\n._selectWithLabel_uazmk_1002 ._selectTrigger_uazmk_307 {\n    border: 1px solid var(--baseBorder);\n  }\n\n._toolbarTitleMode_uazmk_1017 {\n  font-size: var(--text-sm);\n  margin-left: var(--spacing-2);\n}\n\n\n._imageControlWrapperResizing_uazmk_1023 {\n  touch-action: none;\n}\n\n._imageResizer_uazmk_1027 {\n  display: block;\n  width: 7px;\n  height: 7px;\n  position: absolute;\n  background-color: var(--accentText);\n  border: 1px solid var(--baseBg);\n}\n\n._imageResizer_uazmk_1027._imageResizerN_uazmk_1036 {\n  top: -6px;\n  left: 48%;\n  cursor: n-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerNe_uazmk_1042 {\n  top: -6px;\n  right: -6px;\n  cursor: ne-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerE_uazmk_1048 {\n  bottom: 48%;\n  right: -6px;\n  cursor: e-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerSe_uazmk_1054 {\n  bottom: -2px;\n  right: -6px;\n  cursor: nwse-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerS_uazmk_1054 {\n  bottom: -2px;\n  left: 48%;\n  cursor: s-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerSw_uazmk_1066 {\n  bottom: -2px;\n  left: -6px;\n  cursor: sw-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerW_uazmk_1072 {\n  bottom: 48%;\n  left: -6px;\n  cursor: w-resize;\n}\n\n._imageResizer_uazmk_1027._imageResizerNw_uazmk_1078 {\n  top: -6px;\n  left: -6px;\n  cursor: nw-resize;\n}\n\n._placeholder_uazmk_1084 {\n  color: var(--baseSolid);\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  padding: var(--spacing-3);\n  text-overflow: ellipsis;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  white-space: nowrap;\n  display: inline-block;\n  pointer-events: none;\n}\n\n._rootContentEditableWrapper_uazmk_1097 {\n  position: relative;\n}\n\n\n\n._downshiftContainer_uazmk_1103 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n._downshiftInputWrapper_uazmk_1109 {\n  display: flex;\n  align-items: center;\n  background-color: var(--baseBase);\n\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n}\n\n._downshiftInputWrapper_uazmk_1109[data-visible-dropdown=true] {\n    border-bottom-left-radius: var(--radius-none);\n    border-bottom-right-radius: var(--radius-none);\n    border-bottom-width: 0;\n  }\n\n._downshiftInputWrapper_uazmk_1109>button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding-right: var(--spacing-2);\n  }\n\n._downshiftInput_uazmk_1109 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  width: 20rem;\n  padding: var(--spacing-2) var(--spacing-3);\n  font-size: var(--text-sm);\n}\n\n._downshiftInput_uazmk_1109::-moz-placeholder {\n    color: var(--baseBorder);\n  }\n\n._downshiftInput_uazmk_1109::placeholder {\n    color: var(--baseBorder);\n  }\n\n._downshiftAutocompleteContainer_uazmk_1140 {\n  position: relative;\n}\n\n._downshiftAutocompleteContainer_uazmk_1140 ul {\n    all: unset;\n    box-sizing: border-box;\n    position: absolute;\n    font-size: var(--text-sm);\n    width: 100%;\n    display: none;\n    border-bottom-left-radius: var(--radius-medium);\n    border-bottom-right-radius: var(--radius-medium);\n    max-height: var(--spacing-48);\n    overflow-x: hidden;\n    overflow-y: auto;\n    border: 1px solid var(--baseBorder);\n    border-top-width: 0;\n    background-color: var(--baseBase);\n  }\n\n._downshiftAutocompleteContainer_uazmk_1140 ul[data-visible=true] {\n      display: block;\n    }\n\n._downshiftAutocompleteContainer_uazmk_1140 ul li {\n      padding: var(--spacing-2) var(--spacing-3);\n      white-space: nowrap;\n      margin-bottom: var(--spacing-1);\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n    }\n\n._downshiftAutocompleteContainer_uazmk_1140 ul li[data-selected=true] {\n        background-color: var(--baseBgSubtle);\n      }\n\n._downshiftAutocompleteContainer_uazmk_1140 ul li[data-highlighted=true] {\n        background-color: var(--baseBgHover);\n      }\n\n._downshiftAutocompleteContainer_uazmk_1140 ul li:last-of-type {\n        border-bottom-left-radius: var(--radius-medium);\n        border-bottom-right-radius: var(--radius-medium);\n      }\n\n._textInput_uazmk_1186 {\n  all: unset;\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseBase);\n  padding: var(--spacing-2) var(--spacing-3);\n}\n\nform._multiFieldForm_uazmk_1194 {\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-2);\n  gap: var(--spacing-2);\n}\n\nform._multiFieldForm_uazmk_1194 ._formField_uazmk_1200 {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-2);\n  }\n\nform._multiFieldForm_uazmk_1194 ._formField_uazmk_1200 label {\n      font-size: var(--text-xs);\n    }\n\n._markdownParseError_uazmk_1211 {\n  border-radius: var(--radius-base);\n  border: 1px solid var(--error-color);\n  padding: var(--spacing-2);\n  margin-block: var(--spacing-2);\n  color: var(--error-color);\n  font-size: var(--text-xs);\n}\n\n._popupContainer_uazmk_1220 {\n  position: relative;\n  z-index: 2;\n}\n\n._inputSizer_uazmk_1225 {\n  display: inline-grid;\n  vertical-align: baseline;\n  align-items: center;\n  position: relative;\n}\n\n._inputSizer_uazmk_1225::after,\n  ._inputSizer_uazmk_1225 input {\n    width: auto;\n    min-width: 1rem;\n    grid-area: 1 / 2;\n    font: inherit;\n    margin: 0;\n    padding: 0 2px;\n    resize: none;\n    background: none;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    border: none;\n    color: inherit;\n  }\n\n._inputSizer_uazmk_1225 span {\n    padding: 0.25em;\n  }\n\n._inputSizer_uazmk_1225::after {\n    content: attr(data-value);\n    white-space: pre-wrap;\n  }\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --blue-1: #fbfdff;\n  --blue-2: #f4faff;\n  --blue-3: #e6f4fe;\n  --blue-4: #d5efff;\n  --blue-5: #c2e5ff;\n  --blue-6: #acd8fc;\n  --blue-7: #8ec8f6;\n  --blue-8: #5eb1ef;\n  --blue-9: #0090ff;\n  --blue-10: #0588f0;\n  --blue-11: #0d74ce;\n  --blue-12: #113264;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --blue-1: color(display-p3 0.986 0.992 0.999);\n      --blue-2: color(display-p3 0.96 0.979 0.998);\n      --blue-3: color(display-p3 0.912 0.956 0.991);\n      --blue-4: color(display-p3 0.853 0.932 1);\n      --blue-5: color(display-p3 0.788 0.894 0.998);\n      --blue-6: color(display-p3 0.709 0.843 0.976);\n      --blue-7: color(display-p3 0.606 0.777 0.947);\n      --blue-8: color(display-p3 0.451 0.688 0.917);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.234 0.523 0.912);\n      --blue-11: color(display-p3 0.15 0.44 0.84);\n      --blue-12: color(display-p3 0.102 0.193 0.379);\n    }\n  }\n}\n\n._dark_1tncs_1, ._dark-theme_1tncs_1 {\n  --blue-1: #0d1520;\n  --blue-2: #111927;\n  --blue-3: #0d2847;\n  --blue-4: #003362;\n  --blue-5: #004074;\n  --blue-6: #104d87;\n  --blue-7: #205d9e;\n  --blue-8: #2870bd;\n  --blue-9: #0090ff;\n  --blue-10: #3b9eff;\n  --blue-11: #70b8ff;\n  --blue-12: #c2e6ff;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    ._dark_1tncs_1, ._dark-theme_1tncs_1 {\n      --blue-1: color(display-p3 0.057 0.081 0.122);\n      --blue-2: color(display-p3 0.072 0.098 0.147);\n      --blue-3: color(display-p3 0.078 0.154 0.27);\n      --blue-4: color(display-p3 0.033 0.197 0.37);\n      --blue-5: color(display-p3 0.08 0.245 0.441);\n      --blue-6: color(display-p3 0.14 0.298 0.511);\n      --blue-7: color(display-p3 0.195 0.361 0.6);\n      --blue-8: color(display-p3 0.239 0.434 0.72);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.344 0.612 0.973);\n      --blue-11: color(display-p3 0.49 0.72 1);\n      --blue-12: color(display-p3 0.788 0.898 0.99);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --slate-1: #fcfcfd;\n  --slate-2: #f9f9fb;\n  --slate-3: #f0f0f3;\n  --slate-4: #e8e8ec;\n  --slate-5: #e0e1e6;\n  --slate-6: #d9d9e0;\n  --slate-7: #cdced6;\n  --slate-8: #b9bbc6;\n  --slate-9: #8b8d98;\n  --slate-10: #80838d;\n  --slate-11: #60646c;\n  --slate-12: #1c2024;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --slate-1: color(display-p3 0.988 0.988 0.992);\n      --slate-2: color(display-p3 0.976 0.976 0.984);\n      --slate-3: color(display-p3 0.94 0.941 0.953);\n      --slate-4: color(display-p3 0.908 0.909 0.925);\n      --slate-5: color(display-p3 0.88 0.881 0.901);\n      --slate-6: color(display-p3 0.85 0.852 0.876);\n      --slate-7: color(display-p3 0.805 0.808 0.838);\n      --slate-8: color(display-p3 0.727 0.733 0.773);\n      --slate-9: color(display-p3 0.547 0.553 0.592);\n      --slate-10: color(display-p3 0.503 0.512 0.549);\n      --slate-11: color(display-p3 0.379 0.392 0.421);\n      --slate-12: color(display-p3 0.113 0.125 0.14);\n    }\n  }\n}\n\n._dark_1tncs_1, ._dark-theme_1tncs_1 {\n  --slate-1: #111113;\n  --slate-2: #18191b;\n  --slate-3: #212225;\n  --slate-4: #272a2d;\n  --slate-5: #2e3135;\n  --slate-6: #363a3f;\n  --slate-7: #43484e;\n  --slate-8: #5a6169;\n  --slate-9: #696e77;\n  --slate-10: #777b84;\n  --slate-11: #b0b4ba;\n  --slate-12: #edeef0;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    ._dark_1tncs_1, ._dark-theme_1tncs_1 {\n      --slate-1: color(display-p3 0.067 0.067 0.074);\n      --slate-2: color(display-p3 0.095 0.098 0.105);\n      --slate-3: color(display-p3 0.13 0.135 0.145);\n      --slate-4: color(display-p3 0.156 0.163 0.176);\n      --slate-5: color(display-p3 0.183 0.191 0.206);\n      --slate-6: color(display-p3 0.215 0.226 0.244);\n      --slate-7: color(display-p3 0.265 0.28 0.302);\n      --slate-8: color(display-p3 0.357 0.381 0.409);\n      --slate-9: color(display-p3 0.415 0.431 0.463);\n      --slate-10: color(display-p3 0.469 0.483 0.514);\n      --slate-11: color(display-p3 0.692 0.704 0.728);\n      --slate-12: color(display-p3 0.93 0.933 0.94);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --grass-1: #fbfefb;\n  --grass-2: #f5fbf5;\n  --grass-3: #e9f6e9;\n  --grass-4: #daf1db;\n  --grass-5: #c9e8ca;\n  --grass-6: #b2ddb5;\n  --grass-7: #94ce9a;\n  --grass-8: #65ba74;\n  --grass-9: #46a758;\n  --grass-10: #3e9b4f;\n  --grass-11: #2a7e3b;\n  --grass-12: #203c25;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --grass-1: color(display-p3 0.986 0.996 0.985);\n      --grass-2: color(display-p3 0.966 0.983 0.964);\n      --grass-3: color(display-p3 0.923 0.965 0.917);\n      --grass-4: color(display-p3 0.872 0.94 0.865);\n      --grass-5: color(display-p3 0.811 0.908 0.802);\n      --grass-6: color(display-p3 0.733 0.864 0.724);\n      --grass-7: color(display-p3 0.628 0.803 0.622);\n      --grass-8: color(display-p3 0.477 0.72 0.482);\n      --grass-9: color(display-p3 0.38 0.647 0.378);\n      --grass-10: color(display-p3 0.344 0.598 0.342);\n      --grass-11: color(display-p3 0.263 0.488 0.261);\n      --grass-12: color(display-p3 0.151 0.233 0.153);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --cyan-1: #fafdfe;\n  --cyan-2: #f2fafb;\n  --cyan-3: #def7f9;\n  --cyan-4: #caf1f6;\n  --cyan-5: #b5e9f0;\n  --cyan-6: #9ddde7;\n  --cyan-7: #7dcedc;\n  --cyan-8: #3db9cf;\n  --cyan-9: #00a2c7;\n  --cyan-10: #0797b9;\n  --cyan-11: #107d98;\n  --cyan-12: #0d3c48;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --cyan-1: color(display-p3 0.982 0.992 0.996);\n      --cyan-2: color(display-p3 0.955 0.981 0.984);\n      --cyan-3: color(display-p3 0.888 0.965 0.975);\n      --cyan-4: color(display-p3 0.821 0.941 0.959);\n      --cyan-5: color(display-p3 0.751 0.907 0.935);\n      --cyan-6: color(display-p3 0.671 0.862 0.9);\n      --cyan-7: color(display-p3 0.564 0.8 0.854);\n      --cyan-8: color(display-p3 0.388 0.715 0.798);\n      --cyan-9: color(display-p3 0.282 0.627 0.765);\n      --cyan-10: color(display-p3 0.264 0.583 0.71);\n      --cyan-11: color(display-p3 0.08 0.48 0.63);\n      --cyan-12: color(display-p3 0.108 0.232 0.277);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --amber-1: #fefdfb;\n  --amber-2: #fefbe9;\n  --amber-3: #fff7c2;\n  --amber-4: #ffee9c;\n  --amber-5: #fbe577;\n  --amber-6: #f3d673;\n  --amber-7: #e9c162;\n  --amber-8: #e2a336;\n  --amber-9: #ffc53d;\n  --amber-10: #ffba18;\n  --amber-11: #ab6400;\n  --amber-12: #4f3422;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --amber-1: color(display-p3 0.995 0.992 0.985);\n      --amber-2: color(display-p3 0.994 0.986 0.921);\n      --amber-3: color(display-p3 0.994 0.969 0.782);\n      --amber-4: color(display-p3 0.989 0.937 0.65);\n      --amber-5: color(display-p3 0.97 0.902 0.527);\n      --amber-6: color(display-p3 0.936 0.844 0.506);\n      --amber-7: color(display-p3 0.89 0.762 0.443);\n      --amber-8: color(display-p3 0.85 0.65 0.3);\n      --amber-9: color(display-p3 1 0.77 0.26);\n      --amber-10: color(display-p3 0.959 0.741 0.274);\n      --amber-11: color(display-p3 0.64 0.4 0);\n      --amber-12: color(display-p3 0.294 0.208 0.145);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --red-1: #fffcfc;\n  --red-2: #fff7f7;\n  --red-3: #feebec;\n  --red-4: #ffdbdc;\n  --red-5: #ffcdce;\n  --red-6: #fdbdbe;\n  --red-7: #f4a9aa;\n  --red-8: #eb8e90;\n  --red-9: #e5484d;\n  --red-10: #dc3e42;\n  --red-11: #ce2c31;\n  --red-12: #641723;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --red-1: color(display-p3 0.998 0.989 0.988);\n      --red-2: color(display-p3 0.995 0.971 0.971);\n      --red-3: color(display-p3 0.985 0.925 0.925);\n      --red-4: color(display-p3 0.999 0.866 0.866);\n      --red-5: color(display-p3 0.984 0.812 0.811);\n      --red-6: color(display-p3 0.955 0.751 0.749);\n      --red-7: color(display-p3 0.915 0.675 0.672);\n      --red-8: color(display-p3 0.872 0.575 0.572);\n      --red-9: color(display-p3 0.83 0.329 0.324);\n      --red-10: color(display-p3 0.798 0.294 0.285);\n      --red-11: color(display-p3 0.744 0.234 0.222);\n      --red-12: color(display-p3 0.36 0.115 0.143);\n    }\n  }\n}\n\n._bold_1tncs_10 {\n  font-weight: bold;\n}\n\n._italic_1tncs_14 {\n  font-style: italic;\n}\n\n._underline_1tncs_18 {\n  text-decoration: underline;\n}\n\n._bold_1tncs_10 {\n  font-weight: 700;\n}\n\n._italic_1tncs_14 {\n  font-style: italic;\n}\n\n._underline_1tncs_18 {\n  text-decoration: underline\n}\n\n._strikethrough_1tncs_34 {\n  text-decoration: line-through\n}\n\n._underlineStrikethrough_1tncs_38 {\n  text-decoration: underline line-through\n}\n\n._subscript_1tncs_42 {\n  font-size: .8em;\n  vertical-align: sub !important\n}\n\n._superscript_1tncs_47 {\n  font-size: .8em;\n  vertical-align: super\n}\n\n._code_1tncs_52 {\n  background-color: var(--baseBg);\n  padding: 1px .25rem;\n  font-family: var(--font-mono);\n  font-size: 94%\n}\n\n._nestedListItem_1tncs_59 {\n  list-style: none;\n  list-style-type: none;\n}\n\n._nestedListItem_1tncs_59:before,\n._nestedListItem_1tncs_59:after {\n  display: none;\n}\n\n._listitem_1tncs_69 {\n  margin: var(--spacing-2) 0;\n}\n\n._listItemChecked_1tncs_73,\n._listItemUnchecked_1tncs_74 {\n  position: relative;\n  margin-left: 0;\n  margin-right: 0;\n  margin-inline-start: -1rem;\n  padding-left: var(--spacing-6);\n  padding-right: var(--spacing-6);\n  list-style-type: none;\n  outline: none;\n}\n\n._listItemChecked_1tncs_73 {\n  text-decoration: line-through;\n}\n\n._listItemUnchecked_1tncs_74:before,\n._listItemChecked_1tncs_73:before {\n  content: '';\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  display: block;\n  background-size: cover;\n  position: absolute;\n}\n\n._listItemUnchecked_1tncs_74[dir='rtl']:before,\n._listItemChecked_1tncs_73[dir='rtl']:before {\n  left: auto;\n  right: 0;\n}\n\n._listItemUnchecked_1tncs_74:focus:before,\n._listItemChecked_1tncs_73:focus:before {\n  box-shadow: 0 0 0 2px var(--accentBgActive);\n  border-radius: var(--radius-small);\n}\n\n._listItemUnchecked_1tncs_74:before {\n  border: 1px solid var(--baseBorder);\n  border-radius: var(--radius-small);\n}\n\n._listItemChecked_1tncs_73:before {\n  border: 1px solid var(--accentBorder);\n  border-radius: var(--radius-small);\n  background-color: var(--accentSolid);\n  background-repeat: no-repeat;\n}\n\n._listItemChecked_1tncs_73:after {\n  content: '';\n  cursor: pointer;\n  border-color: var(--baseBase);\n  border-style: solid;\n  position: absolute;\n  display: block;\n  top: var(--spacing-0_5);\n  width: var(--spacing-1);\n  left: var(--spacing-1_5);\n  right: var(--spacing-1_5);\n  height: var(--spacing-2);\n  transform: rotate(45deg);\n  border-width: 0 var(--spacing-0_5) var(--spacing-0_5) 0;\n}\n\n._nestedListItem_1tncs_59 {\n  list-style-type: none;\n}\n\n._nestedListItem_1tncs_59:before,\n._nestedListItem_1tncs_59:after {\n  display: none;\n}\n\n._admonitionDanger_1tncs_151,\n._admonitionInfo_1tncs_152,\n._admonitionNote_1tncs_153,\n._admonitionTip_1tncs_154,\n._admonitionCaution_1tncs_155 {\n  padding: var(--spacing-2);\n  margin-top: var(--spacing-2);\n  margin-bottom: var(--spacing-2);\n  border-left: 3px solid var(--admonitionBorder);\n  background-color: var(--admonitionBg);\n}\n\n._admonitionInfo_1tncs_152 {\n  --admonitionBorder: var(--admonitionInfoBorder);\n  --admonitionBg: var(--admonitionInfoBg);\n}\n\n._admonitionTip_1tncs_154 {\n  --admonitionBorder: var(--admonitionTipBorder);\n  --admonitionBg: var(--admonitionTipBg);\n}\n\n._admonitionCaution_1tncs_155 {\n  --admonitionBorder: var(--admonitionCautionBorder);\n  --admonitionBg: var(--admonitionCautionBg);\n}\n\n._admonitionDanger_1tncs_151 {\n  --admonitionBorder: var(--admonitionDangerBorder);\n  --admonitionBg: var(--admonitionDangerBg);\n}\n\n._admonitionNote_1tncs_153 {\n  --admonitionBorder: var(--admonitionNoteBorder);\n  --admonitionBg: var(--admonitionNoteBg);\n}\n\n._mdxExpression_1tncs_188 {\n  font-family: var(--font-mono);\n  font-size: 84%;\n  color: var(--accentText);\n}\n\n._mdxExpression_1tncs_188 input:focus-visible {\n    outline: none;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
